import { useEffect, useState } from 'react';
import { jsPDF } from 'jspdf';
import * as html2canvas from 'html2canvas';
import {
  CalcContainer,
  CalcName,
  CalcTypeCon,
  CalcType,
  CalcTypeUl,
  CalcWrap,
  FilmWrap,
  CalcSettingsWrap,
  NumberCurtainsWrap,
  ColorWrap,
  ChoosePhoto,
  ChooseDiv,
  ChooseText,
  CalcPicture,
  BeltWrap,
  SnakeWrap,
  SnakeLabelWrap,
  Title,
  InstallationWrap,
  RefluxWrap,
  TypeFastening,
  SubTitle,
  FasteningParamsWrap,
  FasteningParamsItem,
  TitleSpan,
  TextileSelect,
  NumberInput,
  ColorSelect,
  NumberSelectDiv,
  FasteningSelect,
  FasteningButton,
  BoxWrap,
  TypeСurtains,
  CustomArrow,
  Plus,
  ParamСurtains,
  ParamСurtainsTitle,
  ParamСurtainsSpan,
  IconButton,
  IconContainer,
  ColorCont,
  SwitcherButton,
  SwitcherWrapper,
  SwitcherWrapperSnake,
  Fasteningwrap,
  FasteningIconContainer,
  ImageContainer,
  OverlayPictureBelt,
  OverlayPictureReflux,
  OverlayPictureSnakeLeft,
  OverlayPictureSnakeRight,
  OverlayPictureSnakeCenter,
  OverlayPictureTopScobLuv,
  OverlayPictureTopLuv,
  OverlayPictureTopPovScob,
  OverlayPictureLeftScobLuv,
  OverlayPictureLeftLuv,
  OverlayPictureLeftPovScob,
  OverlayPictureRightScobLuv,
  OverlayPictureRightLuv,
  OverlayPictureRightPovScob,
  OverlayPictureBottomScobLuv,
  OverlayPictureBottomPovScob,
  OverlayPictureLeftNum,
  OverlayPictureRightNum,
  OverlayPictureBottomKarmPid,
  OverlayPictureBottomArrow,
  OverlayPictureBottomInput,
  UnitLabel,
  OverlayPictureRightArrow,
  InputWrapperBottom,
  InputWrapperRight,
  RemoveButton,
  TitleList,
  CalcWrapList,
  ListParam,
  ListParamText,
  ListItemWrap,
  Price,
  TotalPrice,
  PriceWithoutSale,
  Sale,
  SaleCount,
  SwitcherWrapperSmall,
  NumSaleDiv,
  NumSaleInput,
  PercentageSign,
  OrderButton,
  OverlayPictureTopBar,
  OverlayPictureLeftBar,
  InputWrapperTop,
  InputWrapperTopLeft,
  OverlayPictureTopInput,
  OverlayPictureRefluxArrow,
  InputWrapperReflux,
  OverlayPictureBottomBigBar,
  InputWrapperBottomBegBar,
  OverlayPictureTopBarRight,
  InputWrapperTopRight,
  InputWrapperBottomBig,
  OverlayPictureBottomArrowBig,
  OverlayPictureRightArrowBig,
  InputWrapperRightBig,
  MontageP,
  TotalWrap,
  DopText,
  InputWrapperB,
  OverlayPictureB,
  InputWrapperG,
  OverlayPictureG,
  OverlayPictureG2,
  InputWrapperG2,
  OverlayPictureG3,
  InputWrapperG3,
  OverlayPictureTrick,
  InputWrapperTrick,
  ZipWrap,
  Backdrop,
  Modal,
  Wrap,
  Label,
  OverlayPictureRightBarDown,
  InputWrapperBottomRight,
} from './Calculator.styled';

import type1 from '../../Images/webp/proz.webp';
import type2 from '../../Images/webp/komb.webp';
import type3 from '../../Images/webp/sucil.webp';
import type4 from '../../Images/webp/mosc.webp';
import type5 from '../../Images/webp/trapezoid.webp';
import type6 from '../../Images/webp/T-shapedPolygon.webp';
import type7 from '../../Images/webp/L-shapedPolygon.webp';
import type8 from '../../Images/webp/dom.webp';
import type9 from '../../Images/webp/type9.webp';
import trap from '../../Images/trap.png';
import trap2 from '../../Images/trap2.png';
import lshaped2 from '../../Images/LshapedPolygonR.png';
import komb2 from '../../Images/komb2.png';
import sus_belt from '../../Images/webp/sus_belt.webp';
import trap_belt_image from '../../Images/webp/trap_belt_image.webp';

import green_snake from '../../Images/webp/geen_zip.webp';
import top_scob_luv from '../../Images/webp/top_scob_luv.webp';
import top_luv from '../../Images/webp/top_luv.webp';
import top_scob_luv_trick from '../../Images/top_scob_luv_trick.png';
import top_pov_scob_trick from '../../Images/top_pov_scob_trick.png';
import top_luv_trick from '../../Images/top_luv_trick.png';
import top_pov_scob from '../../Images/webp/top_pov_scob.webp';
import left_scob_luv from '../../Images/webp/left_scob_luv.webp';
import left_luv from '../../Images/webp/left_luv.webp';
import left_pov_scob from '../../Images/webp/left_pov_scob.webp';
import right_scob_luv from '../../Images/webp/right_scob_luv.webp';
import right_luv from '../../Images/webp/right_luv.webp';
import bottom_scob_luv from '../../Images/webp/bottom_scob_luv.webp';
import bottob_scob_luv from '../../Images/bottom_csob_luv_group.png';
import bottom_luv_T from '../../Images/bottom_luv_T.png';
import bottom_pov_scob_T from '../../Images/pov_scob_T.png';
import bottom_pov_scob_L from '../../Images/pov_scob_L.png';
import bottom_luv_L from '../../Images/bottom_luv_L.png';
import bottom_scob_luv_L from '../../Images/bottom_scob_luv_L.png';
import left_num from '../../Images/webp/left_num.webp';
import bottom_arrow from '../../Images/webp/bottom_arrow.webp';
import bottom_arrow_red from '../../Images/webp/bottom_arrow_red.webp';
import left_arrow from '../../Images/webp/small_arrow_left.webp';
import top_arrow from '../../Images/webp/small_arrow_top.webp';
import right_arrow from '../../Images/webp/right_arrow.webp';
import right_arrow_red from '../../Images/webp/right_arrow_red.webp';
import arrow_reflux from '../../Images/webp/arrow_reflux_green.webp';
import big_arrow from '../../Images/webp/big_left_arrow.webp';
import small_arrow from '../../Images/webp/small_arrow.webp';
import small_arrow_gori from '../../Images/webp/small_arrow_horizontal.webp';
import SvgProzora from '../../Images/ProzoraSvg';
import SvgTrapezoid2 from '../../Images/TrapezoidLSvg';
import SvgKomb from '../../Images/KombSvg';
import SvgKomb2 from '../../Images/Komb2Svg';
import SvgSucil from '../../Images/SucilSvg';
import SvgMosc from '../../Images/MoscSvg';
import SvgTrapezoid from '../../Images/TrapezoidSvg';
import SvgKarmanPid from '../../Images/Karman_pidSvg';
import SvgKarmanPidT from '../../Images/Karman_pidTSvg';
import SvgKarmanPidL from '../../Images/Karman_pidLSvg';
import SvgDom from '../../Images/DomSvg';
import SvgLshapedPolygon from '../../Images/L-shapedPolygon';
import SvgTshapedPolygon from '../../Images/T-shapedPolygon';
import SvgTruc from '../../Images/TrucSvg';
import SvgTrap from '../../Images/Trap';
import SvgTrapL2 from '../../Images/TrapezoidL';
import Reflux from '../../Images/Reflux';
import Lreflux from '../../Images/Reflux_LSvg';
import Treflux from '../../Images/Reflux_TSvg';
import SvgRefluxL2 from '../../Images/RefluxL2';
import SvgKarmPidL2 from '../../Images/Karman_pidL2Svg';
import bottom_luvL2 from '../../Images/bottom_luv_L2.png';
import bottom_scob_luvL2 from '../../Images/bottom_scob_luv_L2.png';
import bottom_pov_scobL2 from '../../Images/bottom_pov_scobL2.png';
import luvtrap3 from '../../Images/luvtrap3.png';
import povscobtrap3 from '../../Images/povscobtrap3.png';
import scobluvtrap3 from '../../Images/scobluvtrap3.png';
import luvtrap3L from '../../Images/luvtrap3L.png';
import povscobtrap3L from '../../Images/povscobtrap3L.png';
import scobluvtrap3L from '../../Images/scobluvtrap3L.png';
import numtrap3L from '../../Images/numtrap3L.png';
import numtrap3R from '../../Images/numtrap3R.png';
import luvtrap3R from '../../Images/luvtrap3R.png';
import povscobtrap3R from '../../Images/povscobtrap3R.png';
import scobluvtrap3R from '../../Images/scobluvtrap3R.png';
import red_snake from '../../Images/red_snake.png';
import arrow_komb2 from '../../Images/arrow_komb.png';
import magnetimg from '../../Images/magnet.png';

const Calculator = () => {
  const colorMap = {
    коричневий: '#8B4513',
    жовтий: '#FFD700',
    бежевий: '#F5F5DC',
    червоний: '#FF0000',
    бордовий: '#800000',
    помаранчевий: '#FFA500',
    синій: '#0000FF',
    блакитний: '#87CEFA',
    'темно синій': '#001D3D',
    зелений: '#008000',
    'світло зелений': '#90EE90',
    'темно сірий': '#A9A9A9',
    сірий: '#808080',
    графіт: '#2F4F4F',
    металік: '#6E7B8B',
    чорний: '#000000',
    білий: '#FFFFFF',
  };
  const colorPic = [
    { type: 'Прозора', photo: SvgProzora },
    { type: 'Комбінована', photo: SvgKomb },
    { type: 'Комбінована 2', photo: SvgKomb2 },
    { type: 'Суцільна з ПВХ', photo: SvgSucil },
    { type: 'Москитна Сітка', photo: SvgMosc },
    { type: 'Трапеція', photo: SvgTrapezoid },
    { type: 'Трапеція 2', photo: SvgTrapezoid2 },
    { type: 'T-образний', photo: SvgTshapedPolygon },
    { type: 'L-образний', photo: SvgLshapedPolygon },
    { type: 'L-образний 2', photo: SvgTrapL2 },
    { type: 'Трикутне (Стійки)', photo: SvgDom },
    { type: 'Трапеція 3', photo: SvgTrap },
    { type: 'Трикутне', photo: SvgTruc },
  ];
  const data = [
    { type: 'Прозора', photo: type1 },
    { type: 'Комбінована', photo: type2 },
    { type: 'Комбінована 2', photo: komb2 },
    { type: 'Суцільна з ПВХ', photo: type3 },
    { type: 'Москитна Сітка', photo: type4 },
    { type: 'Трапеція', photo: type5 },
    { type: 'Трапеція 2', photo: trap2 },
    { type: 'T-образний', photo: type6 },
    { type: 'L-образний', photo: type7 },
    { type: 'L-образний 2', photo: lshaped2 },
    { type: 'Трикутне (Стійки)', photo: type8 },
    { type: 'Трапеція 3', photo: trap },
    { type: 'Трикутне', photo: type9 },
  ];
  const arrowMap = {
    'Комбінована 2': arrow_komb2,
  };
  const [prices, setPrices] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);

  // Загружаем цены из localStorage при загрузке
  useEffect(() => {
    const saved = localStorage.getItem('prices');
    if (saved) {
      setPrices(JSON.parse(saved));
    } else {
      // дефолтные значения (если нет сохранённых)
      setPrices({
        film1_37: '0',
        film1_83: '0',
        film1_37ton: '0',
        PVH: '0',
        PVH_500: '0',
        MosquitoNet: '0',
        Pov_Scob: '0',
        Belt: '0',
        Luvers: '0',
        Scob_Luvers: '0',
        Numertvo: '0',
        Lightning: '0',
        Lightning10mm: '0',
        magnet:'0',
      });
    }
  }, []);

  // === изменение цен в модалке ===
  const handleChange = e => {
    setPrices({
      ...prices,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    localStorage.setItem('prices', JSON.stringify(prices));
    alert('Ціни збережено!');
    setModalOpen(false);
  };

  const films = {
    'Achilles 500 мікрон': {
      width: 1370,
      price: prices.film1_37,
      name: 'Achilles 500 мікрон',
    },
    'Achilles 800-1000 мікрон': {
      width: 1830,
      price: prices.film1_83,
      name: 'Achilles 800-1000 мікрон',
    },
    'Achilles 500 мікрон тонована': {
      width: 1370,
      price: prices.film1_37ton,
      name: 'Achilles 500 мікрон тонована',
    },
  };
  const fabricsMap = {
    'ПВХ 630-650 г/м2': {
      label: 'ПВХ 630-650 г/м2',
      price: prices.PVH, // ← поставь свою цену за м²
    },
    'ПВХ 500-550 г/м2': {
      label: 'ПВХ 500-550 г/м2',
      price: prices.PVH_500,
    },
  };

  const topFastenings = {
    top_num: { price: prices.Numertvo, name: 'Намертво', step: 250 }, // Цена для "Намертво" с шагом 25-30 см
    top_scob_luv: {
      price: prices.Scob_Luvers,
      name: 'Скоба + люверс з рем.',
      step: 250,
    }, // Цена для "Скоба + люверс з рем."
    top_luv: { price: prices.Luvers, name: 'Круглі люверси', step: 250 }, // Цена для "Круглі люверси"
    top_pov_scob: {
      price: prices.Pov_Scob,
      name: 'Поворотна скоба',
      step: 250,
    }, // Цена для "Поворотна скоба"
    magnet:{price:prices.magnet, name: "Магніт"},
  };
  const leftFastenings = {
    left_num: { price: prices.Numertvo, name: 'Намертво', step: 250 },
    left_scob_luv: {
      price: prices.Scob_Luvers,
      name: 'Скоба + люверс з рем.',
      step: 250,
    },
    left_luv: { price: prices.Luvers, name: 'Круглі люверси', step: 250 },
    left_pov_scob: {
      price: prices.Pov_Scob,
      name: 'Поворотна скоба',
      step: 250,
    },
    magnet:{price:prices.magnet, name: "Магніт"},
  };
  const rightFastenings = {
    right_num: { price: prices.Numertvo, name: 'Намертво', step: 250 },
    right_scob_luv: {
      price: prices.Scob_Luvers,
      name: 'Скоба + люверс з рем.',
      step: 250,
    },
    right_luv: { price: prices.Luvers, name: 'Круглі люверси', step: 250 },
    right_pov_scob: {
      price: prices.Pov_Scob,
      name: 'Поворотна скоба',
      step: 250,
    },
    magnet:{price:prices.magnet, name: "Магніт"},
  };
  const bottomFastenings = {
    bottom_num: { price: prices.Numertvo, name: 'Намертво', step: 250 },
    bottom_scob_luv: {
      price: prices.Scob_Luvers,
      name: 'Скоба + люверс з рем.',
      step: 250,
    },
    bottom_luv: { price: prices.Luvers, name: 'Круглі люверси', step: 250 },
    bottom_pov_scob: {
      price: prices.Pov_Scob,
      name: 'Поворотна скоба',
      step: 250,
    },
    bottom_karm_pid: { price: 0, name: 'Карман під обтяжувач', width: 200 }, // Ширина кармана 200 мм
    magnet:{price:prices.magnet, name: "Магніт"},
    bottom_karm_z: { price: 0, name: 'Карман з обтяжувачем', width: 200 }, // Ширина кармана 200 мм + брус
  };

  const PriceMosquitoNet = prices.MosquitoNet;

  const PriceOfRunner = 0;
  const PriceOfBelt = prices.Belt;
  const [pdfStatus, setPdfStatus] = useState('generate'); // 'generate' | 'loading' | 'ready'
  const [selectedType, setSelectedType] = useState('Прозора');
  const [activeOptionBelt, setActiveOptionBelt] = useState('Так');
  const [activeOptionInstallation, setActiveOptionInstallation] =
    useState('Так');
  const [activeOptionReflux, setActiveOptionReflux] = useState('Так');
  const [activeOptionSnakeLeft, setActiveOptionSnakeLeft] = useState(false);
  const [activeOptionSnakeCenter, setActiveOptionSnakeCenter] = useState(false);
  const [activeOptionSnakeRight, setActiveOptionSnakeRight] = useState(false);
  const [topSelectedOption, setTopSelectedOption] = useState('top_num');
  const [leftSelectedOption, setLeftSelectedOption] = useState('left_num');
  const [rightSelectedOption, setRightSelectedOption] = useState('right_num');
  const [bottomSelectedOption, setBottomSelectedOption] =
    useState('bottom_karm_pid');
  const [activeOptionMagnetLeft, setactiveOptionMagnetLeft] = useState(false);
  const [activeOptionMagnetCenter, setactiveOptionMagnetCenter] = useState(false);
  const [activeOptionMagnetRight, setactiveOptionMagnetRight] = useState(false);
  const [texttile, setTextile] = useState('Achilles 500 мікрон');
  const [fabrics, setFabrics] = useState('ПВХ 630-650 г/м2');
  const [color, setColor] = useState('коричневий');
  const [width, setWidth] = useState(2400);
  const [height, setHeight] = useState(2050);
  const [widthFilm, setWidthFilm] = useState(0);
  const [heightFilm, setHeightFilm] = useState(0);
  const [widthBar, setWidthBar] = useState(50);
  const [leftBar, setLeftBar] = useState(50);
  const [rightBar, setRightBar] = useState(0);
  const [toprightBar, setTopRightBar] = useState(50);
  const [widthReflux, setWidthReflux] = useState(150);
  const [bottomBar, setBottomBar] = useState(0);
  const [sideOfFilm, setsideOfFilm] = useState(0);
  const [sideOfFilm2, setsideOfFilm2] = useState(0);
  const [sideOfFilm3, setsideOfFilm3] = useState(0);
  const [sideOfFilm4, setsideOfFilm4] = useState(0);
  const [sideOfFilm5, setsideOfFilm5] = useState(0);
  const [snakeSize, setSnakeSize] = useState(15);
  const [count, setCount] = useState(1);
  const [sale, setSale] = useState(0);
  const [markupPercentage, setMarkupPercentage] = useState(0);
  const [customMontagePrice, setCustomMontagePrice] = useState(null);
  const [woodMontage, setWoodMontage] = useState(0);
  const [list, setList] = useState([]);
  const [isHeightFilmChanging, setIsHeightFilmChanging] = useState(false);
  const [isWidthFilmChanging, setIsWidthFilmChanging] = useState(false);
  const numericWidth = parseFloat(width);
  const numericHeight = parseFloat(height);
  const numericWidthFilm = parseFloat(widthFilm);
  const numericHeightFilm = parseFloat(heightFilm);
  const numericCount = parseFloat(count);
  const numericLeftWidthBar = parseFloat(widthBar);
  const numericRightWidthBar = parseFloat(toprightBar);
  const numericLeftBar = parseFloat(leftBar);
  const numericRightBar = parseFloat(rightBar);
  const numericWidthReflux = parseFloat(widthReflux);
  const numericBottomBar = parseFloat(bottomBar);
  const getFilmWidth = films[texttile]?.width / 1000;
  const getFilm = films[texttile];
  const PriceOfTextile = fabricsMap[fabrics]?.price || 0;
  const PriceOfSnake =
    snakeSize === 15 ? prices.Lightning : prices.Lightning10mm;
  const inProductFilm = (numericWidthFilm * numericHeightFilm) / 1000000;

  const handleTypeChange = type => {
    setSelectedType(type);
  };

  const getPhotoByType = type => {
    const item = colorPic.find(item => item.type === type);
    return item;
  };
  const PicByType = ({ selectedType }) => {
    let src;
    switch (selectedType) {
      case 'Трикутне (Стійки)':
        src = left_arrow;
        break;
      case 'Комбінована':
        src = big_arrow;
        break;
      default:
        src = big_arrow;
    }

    return <OverlayPictureBottomBigBar src={src} selectedType={selectedType} />;
  };
  const handleHeightFilmChange = newHeightFilm => {
    setIsHeightFilmChanging(true);
    setHeightFilm(newHeightFilm);
  };

  const handleHeightChange = newHeight => {
    setIsHeightFilmChanging(false);
    setHeight(newHeight);
  };

  useEffect(() => {
    console.log(list);
  }, [list]);

  useEffect(() => {
    if (isHeightFilmChanging && heightFilm > 0) {
      let calculatedHeight;
      if (selectedType === 'Комбінована' || selectedType === 'Комбінована 2') {
        calculatedHeight = heightFilm + numericLeftBar + numericBottomBar;
      } else {
        calculatedHeight = heightFilm + numericLeftBar + numericRightBar;
      }
      setHeight(calculatedHeight);
    } else if (!isHeightFilmChanging && height > 0) {
      let calculatedHeightFilm;
      if (selectedType === 'Комбінована' || selectedType === 'Комбінована 2') {
        calculatedHeightFilm = height - numericLeftBar - numericBottomBar;
      } else {
        calculatedHeightFilm = height - numericLeftBar - numericRightBar;
      }
      setHeightFilm(calculatedHeightFilm);
    }
  }, [
    height,
    heightFilm,
    isHeightFilmChanging,
    selectedType,
    numericLeftBar,
    numericBottomBar,
    numericRightBar,
  ]);

  const handleWidthFilmChange = newWidthFilm => {
    setIsWidthFilmChanging(true);
    setWidthFilm(newWidthFilm);
  };

  // Обработчик изменения внешней ширины
  const handleWidthChange = newWidth => {
    setIsWidthFilmChanging(false);
    setWidth(newWidth);
  };

  useEffect(() => {
    if (isWidthFilmChanging && widthFilm > 0) {
      // Если изменяется внутренняя ширина, пересчитать внешнюю
      const calculatedWidth =
        widthFilm + numericLeftWidthBar + numericRightWidthBar;
      setWidth(calculatedWidth);
    } else if (!isWidthFilmChanging && width > 0) {
      // Если изменяется внешняя ширина, пересчитать внутреннюю
      const calculatedWidthFilm =
        width - numericLeftWidthBar - numericRightWidthBar;
      setWidthFilm(calculatedWidthFilm);
    }
  }, [
    width,
    widthFilm,
    isWidthFilmChanging,
    numericLeftWidthBar,
    numericRightWidthBar,
  ]);
  const calclulateOptimalMosquitoNet = (widthProduct, heightProduct) => {
    const mosquitoNetWidth = 2120 / 1000;
    const productArea = (widthProduct * heightProduct) / 1000000;
    console.log(productArea);
    let bestOption = null;
    let minWaste = Infinity;
    let bestOrientation = '';
    const maxFilms = 10;
    const verticalFilmArea = mosquitoNetWidth * (heightProduct / 1000); // Площадь одной плёнки
    const verticalWaste = verticalFilmArea - productArea;

    if (verticalWaste >= 0) {
      minWaste = verticalWaste;
      bestOption = {
        width: mosquitoNetWidth,
        price: PriceMosquitoNet,
        films: [{ width: mosquitoNetWidth, price: PriceMosquitoNet }],
      };
      bestOrientation = 'вертикальная';
    }

    // Генерируем комбинации плёнок для горизонтальной ориентации
    const filmCombinations = [];
    for (let count = 1; count <= maxFilms; count++) {
      filmCombinations.push(
        Array(count).fill({ width: mosquitoNetWidth, price: PriceMosquitoNet })
      );
    }

    // Рассчёт для горизонтальной ориентации
    filmCombinations.forEach(combination => {
      const totalWidth = combination.length * mosquitoNetWidth; // Суммарная ширина комбинации
      const totalPrice = PriceMosquitoNet * combination.length; // Суммарная цена комбинации
      const horizontalFilmArea = totalWidth * (widthProduct / 1000); // Площадь плёнки
      const horizontalWaste = horizontalFilmArea - productArea;

      if (
        horizontalWaste >= 0 &&
        (horizontalWaste < minWaste ||
          (horizontalWaste === minWaste &&
            totalPrice < (bestOption?.price || Infinity)))
      ) {
        minWaste = horizontalWaste;
        bestOption = {
          width: totalWidth,
          price: totalPrice,
          films: combination,
        };
        bestOrientation = 'горизонтальная';
      }
    });

    return {
      width: bestOption?.width.toFixed(2) || 'не найдено',
      price: bestOption?.price || 'не найдено',
      waste: minWaste.toFixed(2),
      orientation: bestOrientation || 'не найдено',
      films: bestOption?.films || [],
    };
  };


const calculateOptimalFilmCombination = (widthProduct, heightProduct) => {

    if (getFilm.name === 'Achilles 500 мікрон') {
      const filmWidth = 1.37; // Фиксированная ширина плёнки в метрах
      const filmPrice = prices.film1_37; // Цена одной плёнки
      const maxFilms = 10; // Максимальное количество плёнок в комбинации
      const productArea = (widthProduct * heightProduct) / 1000000; // Площадь продукта в м²
      let bestOption = null;
      let minWaste = Infinity;
      let bestOrientation = '';
      // Рассчёт для вертикальной ориентации (только одна плёнка)
      const verticalFilmArea = filmWidth * (heightProduct / 1000); // Площадь одной плёнки
      const verticalWaste = verticalFilmArea - productArea;

      if (verticalWaste >= 0) {





        minWaste = verticalWaste;
        bestOption = {
          width: filmWidth,
          price: filmPrice,
          films: [{ width: filmWidth, price: filmPrice }],
        };
        bestOrientation = 'вертикальная';
      }


      // Генерируем комбинации плёнок для горизонтальной ориентации
      const filmCombinations = [];
      for (let count = 1; count <= maxFilms; count++) {
        filmCombinations.push(
          Array(count).fill({ width: filmWidth, price: filmPrice })
        );
      }


      // Рассчёт для горизонтальной ориентации
      filmCombinations.forEach(combination => {
        const totalWidth = combination.length * filmWidth; // Суммарная ширина комбинации
        const totalPrice = filmPrice * combination.length; // Суммарная цена комбинации
        const horizontalFilmArea = totalWidth * (widthProduct / 1000); // Площадь плёнки
        const horizontalWaste = horizontalFilmArea - productArea;

        if (
          horizontalWaste >= 0 &&
          (horizontalWaste < minWaste ||
            (horizontalWaste === minWaste &&
              totalPrice < (bestOption?.price || Infinity)))
        ) {
          minWaste = horizontalWaste;
          bestOption = {
            width: totalWidth,
            price: totalPrice,
            films: combination,
          };
          bestOrientation = 'горизонтальная';
        }
      });








      return {
        width: bestOption?.width.toFixed(2) || 'не найдено',
        price: getFilm?.price || 'не найдено',
        waste: minWaste.toFixed(2),
        orientation: bestOrientation || 'не найдено',
        films: bestOption?.films || [],
      };
    }
     if (getFilm.name === 'Achilles 800-1000 мікрон') {
      const filmWidth = 1.83; // Фиксированная ширина плёнки в метрах
      const filmPrice = prices.film1_83; // Цена одной плёнки
      const maxFilms = 10; // Максимальное количество плёнок в комбинации
      const productArea = (widthProduct * heightProduct) / 1000000; // Площадь продукта в м²
      let bestOption = null;
      let minWaste = Infinity;
      let bestOrientation = '';
      // Рассчёт для вертикальной ориентации (только одна плёнка)
      const verticalFilmArea = filmWidth * (heightProduct / 1000); // Площадь одной плёнки
      const verticalWaste = verticalFilmArea - productArea;

      if (verticalWaste >= 0) {
        minWaste = verticalWaste;





        bestOption = {
          width: filmWidth,
          price: filmPrice,
          films: [{ width: filmWidth, price: filmPrice }],
        };
        bestOrientation = 'вертикальная';
      }


      // Генерируем комбинации плёнок для горизонтальной ориентации
      const filmCombinations = [];
      for (let count = 1; count <= maxFilms; count++) {
        filmCombinations.push(
          Array(count).fill({ width: filmWidth, price: filmPrice })
        );
      }

      // Рассчёт для горизонтальной ориентации
      filmCombinations.forEach(combination => {
        const totalWidth = combination.length * filmWidth; // Суммарная ширина комбинации
        const totalPrice = filmPrice * combination.length; // Суммарная цена комбинации
        const horizontalFilmArea = totalWidth * (widthProduct / 1000); // Площадь плёнки
        const horizontalWaste = horizontalFilmArea - productArea;

        if (
          horizontalWaste >= 0 &&
          (horizontalWaste < minWaste ||
            (horizontalWaste === minWaste &&
              totalPrice < (bestOption?.price || Infinity)))
        ) {
          minWaste = horizontalWaste;
          bestOption = {
            width: totalWidth,
            price: totalPrice,
            films: combination,
          };
          bestOrientation = 'горизонтальная';
        }
      });

      return {
        width: bestOption?.width.toFixed(2) || 'не найдено',
        price: getFilm?.price || 'не найдено',
        waste: minWaste.toFixed(2),
        orientation: bestOrientation || 'не найдено',
        films: bestOption?.films || [],
      };
    }
    // Проверяем выбранную плёнку
    if (getFilm.name === 'Achilles 500 мікрон тонована') {
      const filmWidth = 1.37; // Фиксированная ширина плёнки в метрах
      const filmPrice = prices.film1_37ton; // Цена одной плёнки
      const maxFilms = 10; // Максимальное количество плёнок в комбинации
      const productArea = (widthProduct * heightProduct) / 1000000; // Площадь продукта в м²
      let bestOption = null;
      let minWaste = Infinity;
      let bestOrientation = '';
      // Рассчёт для вертикальной ориентации (только одна плёнка)
      const verticalFilmArea = filmWidth * (heightProduct / 1000); // Площадь одной плёнки
      const verticalWaste = verticalFilmArea - productArea;

      if (verticalWaste >= 0) {
        minWaste = verticalWaste;
        bestOption = {
          width: filmWidth,
          price: filmPrice,
          films: [{ width: filmWidth, price: filmPrice }],
        };
        bestOrientation = 'вертикальная';
      }

      // Генерируем комбинации плёнок для горизонтальной ориентации
      const filmCombinations = [];
      for (let count = 1; count <= maxFilms; count++) {
        filmCombinations.push(
          Array(count).fill({ width: filmWidth, price: filmPrice })
        );
      }

      // Рассчёт для горизонтальной ориентации
      filmCombinations.forEach(combination => {
        const totalWidth = combination.length * filmWidth; // Суммарная ширина комбинации
        const totalPrice = filmPrice * combination.length; // Суммарная цена комбинации
        const horizontalFilmArea = totalWidth * (widthProduct / 1000); // Площадь плёнки
        const horizontalWaste = horizontalFilmArea - productArea;

        if (
          horizontalWaste >= 0 &&
          (horizontalWaste < minWaste ||
            (horizontalWaste === minWaste &&
              totalPrice < (bestOption?.price || Infinity)))
        ) {
          minWaste = horizontalWaste;
          bestOption = {
            width: totalWidth,
            price: totalPrice,
            films: combination,
          };
          bestOrientation = 'горизонтальная';
        }
      });

      return {
        width: bestOption?.width.toFixed(2) || 'не найдено',
        price: getFilm?.price || 'не найдено',
        waste: minWaste.toFixed(2),
        orientation: bestOrientation || 'не найдено',
        films: bestOption?.films || [],
      };
    }

    

















  };

  const calculateTotalPrice = () => {
    let TotalPriceTextile = 0;
    let TotalPriceFilm = 0;
    let topFasteningPrice = 0;
    let leftFasteningPrice = 0;
    let rightFasteningPrice = 0;
    let getBottomFasteningPrice = 0;
    let snakeLeft = 0;
    let snakeCenter = 0;
    let priceBelt = 0;
    let snakeRight = 0;
    let magnetLeft = 0;
    let magnetCenter = 0;
    let magnetRight = 0;

    const getTopFasteningPrice = topFastenings[topSelectedOption].price;
    const getLeftFasteningPrice = leftFastenings[leftSelectedOption].price;
    const getRightFasteningPrice = rightFastenings[rightSelectedOption].price;

    if (selectedType === 'Прозора') {
      //Висота
      const heightProduct =
        numericHeightFilm === 0
          ? numericHeight
          : numericHeightFilm + numericLeftBar;
      // Ширина
      const widthProduct =
        numericWidthFilm === 0
          ? numericWidth
          : numericWidthFilm + numericLeftWidthBar + numericRightWidthBar;
      // Ткань
      // левая стойка
      const leftTextileBar =
        ((numericLeftWidthBar * 2 + 50) * heightProduct) / 1000000;
      //  правая стойка
      const rightTextileBar =
        ((numericRightWidthBar * 2 + 50) * heightProduct) / 1000000;
      // верх стойка
      const topTextileBar =
        ((numericLeftBar * 2 + 50) * widthProduct) / 1000000;
      // низ стойка
      const bottomTextileBar = ( (numericRightBar * 2 + 50)  * widthProduct) / 1000000;
      // отлив
      const reflux =
        activeOptionReflux === 'Так'
          ? (numericWidthReflux * widthProduct) / 1000000
          : 0;
      // общая площадь ткани
      const totalTextile =
        Math.round(
          (leftTextileBar +
            rightTextileBar +
            topTextileBar +
            bottomTextileBar +
            reflux) *
            100
        ) / 100;
      TotalPriceTextile = PriceOfTextile * totalTextile;
      // Пленка
      const filmResult = calculateOptimalFilmCombination(
        widthFilm,
        heightFilm,
        texttile
      );
      console.log('👉 Ответ :', filmResult);
      if (filmResult) {
        // Определяем базовую ширину плёнки для расчёта стоимости
        const baseFilmWidth = filmResult.films[0].width;
        const baseFilmPrice = filmResult.films[0].price;
        const filmResultWidth = filmResult.width;
        // Рассчитываем стоимость на основе ориентации
        const calculatedArea =
          filmResult.orientation === 'вертикальная'
            ? baseFilmWidth * (heightProduct / 1000) // Площадь плёнки при вертикальной ориентации
            : filmResultWidth * (widthProduct / 1000); // Площадь плёнки при горизонтальной ориентации
        const numOfFilms = filmResult.films.length;
        // Вычисляем стоимость плёнки, умножая площадь на цену за единицу плёнки
        TotalPriceFilm = calculatedArea * baseFilmPrice;
      } else {
        console.log(
          'Не удалось найти подходящую комбинацию плёнок для изделия.'
        );
      }
      // Крепления
      topFasteningPrice = Math.round(
        getTopFasteningPrice * (widthProduct / 250)
      );
      leftFasteningPrice = Math.round(
        getLeftFasteningPrice * (heightProduct / 250)
      );
      rightFasteningPrice = Math.round(
        getRightFasteningPrice * (heightProduct / 250)
      );
      // Молния
      snakeLeft =
        activeOptionSnakeLeft === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
      snakeCenter =
        activeOptionSnakeCenter === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
      snakeRight =
        activeOptionSnakeRight === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
          //Магніт 
          magnetLeft =
        activeOptionMagnetLeft === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      magnetCenter =
        activeOptionMagnetCenter === true
          ? (heightProduct / 250) * prices.magnet  
          : 0;
      magnetRight =
        activeOptionMagnetRight === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      // Ремень
      priceBelt =
        activeOptionBelt === 'Так'
          ? Math.round(widthProduct / 1500) * PriceOfBelt
          : 0;
      getBottomFasteningPrice =
        bottomFastenings[bottomSelectedOption].price * (widthProduct / 250);

      console.log(
        // TotalPriceFilm,
        // 'TotalPriceFilm',
        // TotalPriceTextile,
        // 'TotalPriceTextile',
        // topFasteningPrice,
        // 'topFasteningPrice',
        // leftFasteningPrice,
        // 'leftFasteningPrice',
        // rightFasteningPrice,
        // 'rightFasteningPrice',
        // getBottomFasteningPrice,
        // 'getBottomFasteningPrice'
        // topSelectedOption
      );
    } else if (selectedType === 'Комбінована') {
      //Висота
      const heightProduct =
        numericHeightFilm + numericLeftBar + numericBottomBar;
      // Ширина
      const widthProduct =
        numericWidthFilm + numericLeftBar + numericRightWidthBar;
      // Ткань
      // левая стойка
      const leftTextileBar =
        ((numericLeftWidthBar * 2 + 50) * heightProduct) / 1000000;
      //  правая стойка
      const rightTextileBar =
        ((numericRightWidthBar * 2 + 50) * heightProduct) / 1000000;
      // верх стойка было ((width * (numericLeftBar + 75)) / 1000000;)
     const topTextileBar =  ((numericLeftBar * 2 + 50) * widthProduct) / 1000000;
      // низ стойка было ( (numericBottomBar *(numericWidthFilm + numericLeftWidthBar + numericRightWidthBar)) /1000000;)
      const bottomTextileBar = ( (numericRightBar * 2 + 50)  * widthProduct) / 1000000;

      // отлив
      const reflux =
        activeOptionReflux === 'Так'
          ? (numericWidthReflux * widthProduct) / 1000000
          : 0;
      // общая площадь ткани
      const totalTextile =
        Math.round(
          (leftTextileBar +
            rightTextileBar +
            topTextileBar +
            bottomTextileBar +
            reflux) *
            100
        ) / 100;
      TotalPriceTextile = PriceOfTextile * totalTextile;
      // Пленка
      const filmResult = calculateOptimalFilmCombination(
        widthFilm,
        heightFilm,
        texttile
      );
      console.log('👉 Ответ :', filmResult);
      if (filmResult) {
        // Определяем базовую ширину плёнки для расчёта стоимости
        const baseFilmWidth = filmResult.films[0].width;
        const filmResultWidth = filmResult.width;
        // Рассчитываем стоимость на основе ориентации
        const calculatedArea =
          filmResult.orientation === 'вертикальная'
            ? baseFilmWidth * (heightProduct / 1000) // Площадь плёнки при вертикальной ориентации
            : filmResultWidth * (widthProduct / 1000); // Площадь плёнки при горизонтальной ориентации
        // Вычисляем стоимость плёнки, умножая площадь на цену за единицу плёнки
        TotalPriceFilm = calculatedArea * filmResult.films[0].price;
      }
      // Крепления
      topFasteningPrice = Math.round(
        getTopFasteningPrice * (widthProduct / 250)
      );
      leftFasteningPrice = Math.round(
        getLeftFasteningPrice * (heightProduct / 250)
      );
      rightFasteningPrice = Math.round(
        getRightFasteningPrice * (heightProduct / 250)
      );
      // Молния
      snakeLeft =
        activeOptionSnakeLeft === true
          ? (heightProduct / 1000) * PriceOfSnake
          : 0;
      snakeCenter =
        activeOptionSnakeCenter === true
          ? (heightProduct / 1000) * PriceOfSnake
          : 0;
      snakeRight =
        activeOptionSnakeRight === true
          ? (heightProduct / 1000) * PriceOfSnake
          : 0;
           //Магніт 
          magnetLeft =
        activeOptionMagnetLeft === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      magnetCenter =
        activeOptionMagnetCenter === true
          ? (heightProduct / 250) * prices.magnet  
          : 0;
      magnetRight =
        activeOptionMagnetRight === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      // Ремень
      priceBelt =
        activeOptionBelt === 'Так'
          ? Math.round(widthProduct / 1500) * PriceOfBelt
          : 0;
      getBottomFasteningPrice =
        bottomFastenings[bottomSelectedOption].price * (widthProduct / 250);
      // console.log(
      //   heightProduct
      //   // TotalPriceFilm,
      //   // 'TotalPriceFilm',
      //   // TotalPriceTextile,
      //   // 'TotalPriceTextile',
      //   // topFasteningPrice,
      //   // 'topFasteningPrice',
      //   // leftFasteningPrice,
      //   // 'leftFasteningPrice',
      //   // rightFasteningPrice,
      //   // 'rightFasteningPrice',
      //   // getBottomFasteningPrice,
      //   // 'getBottomFasteningPrice'
      // );
    } else if (selectedType === 'Комбінована 2') {
      //Висота
      const heightProduct =
        numericHeightFilm + numericLeftBar + numericBottomBar;
      // Ширина
      const widthProduct =
        numericWidthFilm + numericLeftBar + numericRightWidthBar;
      // Ткань
      // левая стойка
      const leftTextileBar =
        ((numericLeftWidthBar * 2 + 50) * heightProduct) / 1000000;
      //  правая стойка
      const rightTextileBar =
        ((numericRightWidthBar * 2 + 50) * heightProduct) / 1000000;
      // верх стойка было ((width * (numericLeftBar + 75)) / 1000000;)
      const topTextileBar = ((numericLeftBar * 2 + 50) * widthProduct) / 1000000;
      // низ стойка было ((numericBottomBar * (width + 200)) / 1000000;)
       const bottomTextileBar = ( (numericRightBar * 2 + 50)  * widthProduct) / 1000000;

      // отлив
      const reflux =
        activeOptionReflux === 'Так'
          ? (numericWidthReflux * widthProduct) / 1000000
          : 0;
      // общая площадь ткани
      const totalTextile =
        Math.round(
          (leftTextileBar +
            rightTextileBar +
            topTextileBar +
            bottomTextileBar +
            reflux) *
            100
        ) / 100;
      TotalPriceTextile = PriceOfTextile * totalTextile;
      // Пленка
      const filmResult = calculateOptimalFilmCombination(
        widthFilm,
        heightFilm,
        texttile
      );
      if (filmResult) {
        // Определяем базовую ширину плёнки для расчёта стоимости
        const baseFilmWidth = filmResult.films[0].width;
        const filmResultWidth = filmResult.width;
        // Рассчитываем стоимость на основе ориентации
        const calculatedArea =
          filmResult.orientation === 'вертикальная'
            ? baseFilmWidth * (heightProduct / 1000) // Площадь плёнки при вертикальной ориентации
            : filmResultWidth * (widthProduct / 1000); // Площадь плёнки при горизонтальной ориентации
        // Вычисляем стоимость плёнки, умножая площадь на цену за единицу плёнки
        TotalPriceFilm = calculatedArea * filmResult.films[0].price;
      }
      // Крепления
      topFasteningPrice = Math.round(
        getTopFasteningPrice * (widthProduct / 250)
      );
      leftFasteningPrice = Math.round(
        getLeftFasteningPrice * (heightProduct / 250)
      );
      rightFasteningPrice = Math.round(
        getRightFasteningPrice * (heightProduct / 250)
      );
      // Молния
      snakeLeft =
        activeOptionSnakeLeft === true
          ? (heightProduct / 1000) * PriceOfSnake
          : 0;
      snakeCenter =
        activeOptionSnakeCenter === true
          ? (heightProduct / 1000) * PriceOfSnake
          : 0;
      snakeRight =
        activeOptionSnakeRight === true
          ? (heightProduct / 1000) * PriceOfSnake
          : 0;
           //Магніт 
          magnetLeft =
        activeOptionMagnetLeft === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      magnetCenter =
        activeOptionMagnetCenter === true
          ? (heightProduct / 250) * prices.magnet  
          : 0;
      magnetRight =
        activeOptionMagnetRight === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      // Ремень
      priceBelt =
        activeOptionBelt === 'Так'
          ? Math.round(widthProduct / 1500) * PriceOfBelt
          : 0;
      getBottomFasteningPrice =
        bottomFastenings[bottomSelectedOption].price * (widthProduct / 250);
      console.log(
        totalTextile
        // TotalPriceFilm,
        // 'TotalPriceFilm',
        // TotalPriceTextile,
        // 'TotalPriceTextile',
        // topFasteningPrice,
        // 'topFasteningPrice',
        // leftFasteningPrice,
        // 'leftFasteningPrice',
        // rightFasteningPrice,
        // 'rightFasteningPrice',
        // getBottomFasteningPrice,
        // 'getBottomFasteningPrice'
      );
    } else if (selectedType === 'Суцільна з ПВХ') {
      // const reflux =
      //   activeOptionReflux === 'Так'
      //     ? Math.floor(
      //         ((numericWidthReflux * numericWidthFilm) / 1000000) * 100
      //       ) / 100
      //     : 0;
      // const nWidth = numericWidth;
      // const nHeight = numericHeight;
      // const textile =
      //   Math.floor((((nWidth + 120) * (nHeight + 120)) / 1000000) * 100) / 100;
      // const totalTextile = Math.floor((textile + reflux) * 100) / 100;
      // TotalPriceTextile = PriceOfTextile * totalTextile;
       //Висота
      const heightProduct = numericHeight;
      // Ширина
      const widthProduct = numericWidth;
      const SProduct = (heightProduct + numericLeftBar + numericRightBar) * (widthProduct + numericLeftWidthBar + numericRightWidthBar) / 1000000;

      // отлив
      const reflux =
        activeOptionReflux === 'Так'
          ? (numericWidthReflux * widthProduct) / 1000000
          : 0;
      // общая площадь ткани
      const totalTextile =
        Math.round(
          (
            // leftTextileBar +
            // rightTextileBar +
            // topTextileBar +
            // bottomTextileBar 
            SProduct+
            reflux) *
            100
        ) / 100;
      TotalPriceTextile = PriceOfTextile * totalTextile;
      TotalPriceFilm = 0;
      // Крепления
      topFasteningPrice = Math.round(getTopFasteningPrice * (widthProduct / 250));
      leftFasteningPrice = Math.round(getLeftFasteningPrice * (heightProduct / 250));
      rightFasteningPrice = Math.round(
        getRightFasteningPrice * (heightProduct / 250)
      );
      // Молния
      snakeLeft =
        activeOptionSnakeLeft === true ? (heightProduct / 1000) * PriceOfSnake : 0;
      snakeCenter =
        activeOptionSnakeCenter === true ? (heightProduct / 1000) * PriceOfSnake : 0;
      snakeRight =
        activeOptionSnakeRight === true ? (heightProduct / 1000) * PriceOfSnake : 0;
       //Магніт 
          magnetLeft =
        activeOptionMagnetLeft === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      magnetCenter =
        activeOptionMagnetCenter === true
          ? (heightProduct / 250) * prices.magnet  
          : 0;
      magnetRight =
        activeOptionMagnetRight === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
        // Ремень
      priceBelt =
        activeOptionBelt === 'Так'
          ? Math.round(widthProduct / 1500) * PriceOfBelt
          : 0;
      getBottomFasteningPrice =
        bottomFastenings[bottomSelectedOption].price * (widthProduct / 250);
          console.log(
   totalTextile ,PriceOfTextile
      );
    } else if (selectedType === 'Москитна Сітка') {
      //Висота
      const heightProduct =
        numericHeightFilm === 0
          ? numericHeight
          : numericHeightFilm + numericLeftBar;
      // Ширина
      const widthProduct =
        numericWidthFilm === 0
          ? numericWidth
          : numericWidthFilm + numericLeftWidthBar + numericRightWidthBar;
      // Ткань
      // левая стойка
      const leftTextileBar =
        ((numericLeftWidthBar * 2 + 50) * heightProduct) / 1000000;
      //  правая стойка
      const rightTextileBar =
        ((numericRightWidthBar * 2 + 50) * heightProduct) / 1000000;
      // верх стойка
      const topTextileBar =
        ((numericLeftBar * 2 + 50) * widthProduct) / 1000000;
      // низ стойка
            const bottomTextileBar = ( (numericRightBar * 2 + 50)  * widthProduct) / 1000000;

      // отлив
      const reflux =
        activeOptionReflux === 'Так'
          ? (numericWidthReflux * widthProduct) / 1000000
          : 0;
      // общая площадь ткани
      const totalTextile =
        Math.round(
          (leftTextileBar +
            rightTextileBar +
            topTextileBar +
            bottomTextileBar +
            reflux) *
            100
        ) / 100;
      TotalPriceTextile = PriceOfTextile * totalTextile;
      const mosquitoNet = calclulateOptimalMosquitoNet(
        widthProduct,
        heightProduct
      );
      if (mosquitoNet) {
        // Определяем базовую ширину плёнки для расчёта стоимости
        const baseFilmWidth = mosquitoNet.films[0].width;
        const filmResultWidth = mosquitoNet.width;
        // Рассчитываем стоимость на основе ориентации
        const calculatedArea =
          mosquitoNet.orientation === 'вертикальная'
            ? baseFilmWidth * (heightProduct / 1000) // Площадь плёнки при вертикальной ориентации
            : filmResultWidth * (widthProduct / 1000); // Площадь плёнки при горизонтальной ориентации
        // Вычисляем стоимость плёнки, умножая площадь на цену за единицу плёнки
        TotalPriceFilm = calculatedArea * mosquitoNet.films[0].price;
      }
      // Крепления
      topFasteningPrice = Math.round(
        getTopFasteningPrice * (widthProduct / 250)
      );
      leftFasteningPrice = Math.round(
        getLeftFasteningPrice * (heightProduct / 250)
      );
      rightFasteningPrice = Math.round(
        getRightFasteningPrice * (heightProduct / 250)
      );
      // Молния
      snakeLeft =
        activeOptionSnakeLeft === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
      snakeCenter =
        activeOptionSnakeCenter === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
      snakeRight =
        activeOptionSnakeRight === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
           //Магніт 
          magnetLeft =
        activeOptionMagnetLeft === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      magnetCenter =
        activeOptionMagnetCenter === true
          ? (heightProduct / 250) * prices.magnet  
          : 0;
      magnetRight =
        activeOptionMagnetRight === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      // Ремень
      priceBelt =
        activeOptionBelt === 'Так'
          ? Math.round(widthProduct / 1500) * PriceOfBelt
          : 0;
      getBottomFasteningPrice =
        bottomFastenings[bottomSelectedOption].price * (widthProduct / 250);
    } else if (
      selectedType === 'Трапеція' ||
      selectedType === 'Трапеція 2' ||
      selectedType === 'Трапеція 3'
    ) {
      //Висота
      const heightProduct = numericHeightFilm + numericLeftBar;
      // Ширина
      const widthProduct =
        numericWidthFilm + numericLeftBar + numericRightWidthBar;
      // Ткань
      // левая стойка
      const leftTextileBar =
        ((numericLeftWidthBar * 2 + 50) * heightProduct) / 1000000;
      //  правая стойка
      const rightTextileBar =
        ((numericRightWidthBar * 2 + 50) * heightProduct) / 1000000;
      // верх стойка
      const topTextileBar = ((numericLeftBar * 2 + 50) * width) / 1000000;
      // низ стойка
      const bottomTextileBar = ( (numericRightBar * 2 + 50)  * widthProduct) / 1000000;

      // отлив
      const reflux =
        activeOptionReflux === 'Так'
          ? (numericWidthReflux * widthProduct) / 1000000
          : 0;
      // общая площадь ткани
      const totalTextile =
        Math.round(
          (leftTextileBar +
            rightTextileBar +
            topTextileBar +
            bottomTextileBar +
            reflux) *
            100
        ) / 100;
      TotalPriceTextile = PriceOfTextile * totalTextile;
      // Пленка
      const filmResult = calculateOptimalFilmCombination(
        widthFilm,
        heightFilm,
        texttile
      );
      console.log('👉 Ответ :', filmResult);
      if (filmResult) {
        // Определяем базовую ширину плёнки для расчёта стоимости
        const baseFilmWidth = filmResult.films[0].width;
        const baseFilmPrice = filmResult.films[0].price;
        const filmResultWidth = filmResult.width;
        // Рассчитываем стоимость на основе ориентации
        const calculatedArea =
          filmResult.orientation === 'вертикальная'
            ? baseFilmWidth * (heightProduct / 1000) // Площадь плёнки при вертикальной ориентации
            : filmResultWidth * (widthProduct / 1000); // Площадь плёнки при горизонтальной ориентации
        // Вычисляем стоимость плёнки, умножая площадь на цену за единицу плёнки
        TotalPriceFilm = calculatedArea * baseFilmPrice;
      }
      // Крепления
      topFasteningPrice = Math.round(
        getTopFasteningPrice * (widthProduct / 250)
      );
      leftFasteningPrice = Math.round(
        getLeftFasteningPrice * (heightProduct / 250)
      );
      rightFasteningPrice = Math.round(
        getRightFasteningPrice * (heightProduct / 250)
      );
      // Молния
      snakeLeft =
        activeOptionSnakeLeft === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
      snakeCenter =
        activeOptionSnakeCenter === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
      snakeRight =
        activeOptionSnakeRight === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
           //Магніт 
          magnetLeft =
        activeOptionMagnetLeft === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      magnetCenter =
        activeOptionMagnetCenter === true
          ? (heightProduct / 250) * prices.magnet  
          : 0;
      magnetRight =
        activeOptionMagnetRight === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      // Ремень
      priceBelt =
        activeOptionBelt === 'Так'
          ? Math.round(widthProduct / 1500) * PriceOfBelt
          : 0;
      getBottomFasteningPrice =
        bottomFastenings[bottomSelectedOption].price * (widthProduct / 250);
    } else if (selectedType === 'T-образний') {
      //Висота
      const heightProduct = numericHeightFilm + numericLeftBar;
      // Ширина
      const widthProduct =
        numericWidthFilm + numericLeftBar + numericRightWidthBar;
      // Ткань
      // левая стойка
      const leftTextileBar =
        ((numericLeftWidthBar * 2 + 50) * heightProduct) / 1000000;
      //  правая стойка
      const rightTextileBar =
        ((numericRightWidthBar * 2 + 50) * heightProduct) / 1000000;
      // верх стойка
      const topTextileBar = ((numericLeftBar * 2 + 50) * width) / 1000000;
      // низ стойка
      const bottomTextileBar = ( (numericRightBar * 2 + 50)  * widthProduct) / 1000000;
      // отлив
      const reflux =
        activeOptionReflux === 'Так'
          ? (numericWidthReflux * widthProduct) / 1000000
          : 0;
      // общая площадь ткани
      const totalTextile =
        Math.round(
          (leftTextileBar +
            rightTextileBar +
            topTextileBar +
            bottomTextileBar +
            reflux) *
            100
        ) / 100;
      TotalPriceTextile = PriceOfTextile * totalTextile;
      // Пленка
      const filmResult = calculateOptimalFilmCombination(
        widthFilm,
        heightFilm,
        texttile
      );

      if (filmResult) {
        // Определяем базовую ширину плёнки для расчёта стоимости
        const baseFilmWidth = filmResult.films[0].width;
        const filmResultWidth = filmResult.width;
        // Рассчитываем стоимость на основе ориентации
        const calculatedArea =
          filmResult.orientation === 'вертикальная'
            ? baseFilmWidth * (heightProduct / 1000) // Площадь плёнки при вертикальной ориентации
            : filmResultWidth * (widthProduct / 1000); // Площадь плёнки при горизонтальной ориентации
        // Вычисляем стоимость плёнки, умножая площадь на цену за единицу плёнки
        TotalPriceFilm = calculatedArea * filmResult.films[0].price;
      }
      // Крепления
      topFasteningPrice = Math.round(
        getTopFasteningPrice * (widthProduct / 250)
      );
      leftFasteningPrice = Math.round(
        getLeftFasteningPrice * (heightProduct / 250)
      );
      rightFasteningPrice = Math.round(
        getRightFasteningPrice * (heightProduct / 250)
      );
      // Молния
      snakeLeft =
        activeOptionSnakeLeft === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
      snakeCenter =
        activeOptionSnakeCenter === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
      snakeRight =
        activeOptionSnakeRight === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
           //Магніт 
          magnetLeft =
        activeOptionMagnetLeft === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      magnetCenter =
        activeOptionMagnetCenter === true
          ? (heightProduct / 250) * prices.magnet  
          : 0;
      magnetRight =
        activeOptionMagnetRight === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      // Ремень
      priceBelt =
        activeOptionBelt === 'Так'
          ? Math.round(widthProduct / 1500) * PriceOfBelt
          : 0;
      getBottomFasteningPrice =
        bottomFastenings[bottomSelectedOption].price * (widthProduct / 250);
    } else if (
      selectedType === 'L-образний' ||
      selectedType === 'L-образний 2'
    ) {
      //Висота
      const heightProduct = numericHeightFilm + numericLeftBar;
      // Ширина
      const widthProduct =
        numericWidthFilm + numericLeftBar + numericRightWidthBar;
      // Ткань
      // левая стойка
      const leftTextileBar =
        ((numericLeftWidthBar * 2 + 50) * heightProduct) / 1000000;
      //  правая стойка
      const rightTextileBar =
        ((numericRightWidthBar * 2 + 50) * heightProduct) / 1000000;
      // верх стойка
      const topTextileBar = ((numericLeftBar * 2 + 50) * width) / 1000000;
      // низ стойка
      const bottomTextileBar = ( (numericRightBar * 2 + 50)  * widthProduct) / 1000000;
      // отлив
      const reflux =
        activeOptionReflux === 'Так'
          ? (numericWidthReflux * widthProduct) / 1000000
          : 0;
      // общая площадь ткани
      const totalTextile =
        Math.round(
          (leftTextileBar +
            rightTextileBar +
            topTextileBar +
            bottomTextileBar +
            reflux) *
            100
        ) / 100;
      TotalPriceTextile = PriceOfTextile * totalTextile;
      // Пленка
      const filmResult = calculateOptimalFilmCombination(
        widthFilm,
        heightFilm,
        texttile
      );
      if (filmResult) {
        // Определяем базовую ширину плёнки для расчёта стоимости
        const baseFilmWidth = filmResult.films[0].width;
        const filmResultWidth = filmResult.width;
        // Рассчитываем стоимость на основе ориентации
        const calculatedArea =
          filmResult.orientation === 'вертикальная'
            ? baseFilmWidth * (heightProduct / 1000) // Площадь плёнки при вертикальной ориентации
            : filmResultWidth * (widthProduct / 1000); // Площадь плёнки при горизонтальной ориентации
        // Вычисляем стоимость плёнки, умножая площадь на цену за единицу плёнки
        TotalPriceFilm = calculatedArea * filmResult.films[0].price;
      }
      // Крепления
      topFasteningPrice = Math.round(
        getTopFasteningPrice * (widthProduct / 250)
      );
      leftFasteningPrice = Math.round(
        getLeftFasteningPrice * (heightProduct / 250)
      );
      rightFasteningPrice = Math.round(
        getRightFasteningPrice * (heightProduct / 250)
      );
      // Молния
      snakeLeft =
        activeOptionSnakeLeft === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
      snakeCenter =
        activeOptionSnakeCenter === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
      snakeRight =
        activeOptionSnakeRight === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
           //Магніт 
          magnetLeft =
        activeOptionMagnetLeft === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      magnetCenter =
        activeOptionMagnetCenter === true
          ? (heightProduct / 250) * prices.magnet  
          : 0;
      magnetRight =
        activeOptionMagnetRight === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      // Ремень
      priceBelt =
        activeOptionBelt === 'Так'
          ? Math.round(widthProduct / 1500) * PriceOfBelt
          : 0;
      getBottomFasteningPrice =
        bottomFastenings[bottomSelectedOption].price * (widthProduct / 250);
    } else if (
      selectedType === 'Трикутне (Стійки)' ||
      selectedType === 'Трикутне'
    ) {
      //Висота
      const heightProduct = numericHeightFilm + numericLeftBar;
      // Ширина
      const widthProduct =
        numericWidthFilm + numericLeftBar + numericRightWidthBar;
      // Ткань
      // левая стойка
      const leftTextileBar =
        ((numericLeftWidthBar * 2 + 50) * heightProduct) / 1000000;
      //  правая стойка
      const rightTextileBar =
        ((numericRightWidthBar * 2 + 50) * heightProduct) / 1000000;
      // верх стойка
      const topTextileBar = ((numericLeftBar * 2 + 50) * width) / 1000000;
      // низ стойка
      const bottomTextileBar = ( (numericRightBar * 2 + 50)  * widthProduct) / 1000000;

      // отлив
      const reflux =
        activeOptionReflux === 'Так'
          ? (numericWidthReflux * widthProduct) / 1000000
          : 0;
      // общая площадь ткани
      const totalTextile =
        Math.round(
          (leftTextileBar +
            rightTextileBar +
            topTextileBar +
            bottomTextileBar +
            reflux) *
            100
        ) / 100;
      TotalPriceTextile = PriceOfTextile * totalTextile;
      // Пленка
      const filmResult = calculateOptimalFilmCombination(
        widthFilm,
        heightFilm,
        texttile
      );
      if (filmResult) {
        // Определяем базовую ширину плёнки для расчёта стоимости
        const baseFilmWidth = filmResult.films[0].width;
        const filmResultWidth = filmResult.width;
        // Рассчитываем стоимость на основе ориентации
        const calculatedArea =
          filmResult.orientation === 'вертикальная'
            ? baseFilmWidth * (widthProduct / 1000) // Площадь плёнки при вертикальной ориентации
            : filmResultWidth * (widthProduct / 1000); // Площадь плёнки при горизонтальной ориентации
        // Вычисляем стоимость плёнки, умножая площадь на цену за единицу плёнки
        TotalPriceFilm = calculatedArea * filmResult.films[0].price;
      }
      // Крепления
      topFasteningPrice = Math.round(
        getTopFasteningPrice * (widthProduct / 250)
      );
      leftFasteningPrice = Math.round(
        getLeftFasteningPrice * (heightProduct / 250)
      );
      rightFasteningPrice = Math.round(
        getRightFasteningPrice * (heightProduct / 250)
      );
      // Молния
      snakeLeft =
        activeOptionSnakeLeft === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
      snakeCenter =
        activeOptionSnakeCenter === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
      snakeRight =
        activeOptionSnakeRight === true
          ? (heightProduct / 1000) * PriceOfSnake + PriceOfRunner
          : 0;
           //Магніт 
          magnetLeft =
        activeOptionMagnetLeft === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      magnetCenter =
        activeOptionMagnetCenter === true
          ? (heightProduct / 250) * prices.magnet  
          : 0;
      magnetRight =
        activeOptionMagnetRight === true
          ? (heightProduct / 250) * prices.magnet 
          : 0;
      // Ремень
      priceBelt =
        activeOptionBelt === 'Так'
          ? Math.round(widthProduct / 1500) * PriceOfBelt
          : 0;
      getBottomFasteningPrice =
        bottomFastenings[bottomSelectedOption].price * (widthProduct / 250);
    }
    // Расчет карманов
    const widthProduct = numericWidth; // Определяем widthProduct из numericWidth
    const calculatePocketArea = (width, length) => {
      return (width * length) / 1000000; // Площадь в м²
    };

    // Карман под обтяжитель
    if (bottomSelectedOption === 'bottom_karm_pid') {
      const pocketLength = widthProduct / 1000; // Длина кармана в метрах
      const pocketArea = calculatePocketArea(200, pocketLength * 1000); // Площадь кармана в м²
      TotalPriceTextile += PriceOfTextile * pocketArea;
    }

    // Карман с обтяжителем
    if (bottomSelectedOption === 'bottom_karm_z') {
      const pocketLength = widthProduct / 1000; // Длина кармана в метрах
      const pocketArea = calculatePocketArea(200, pocketLength * 1000); // Площадь кармана в м²
      TotalPriceTextile += PriceOfTextile * pocketArea;
      // Добавляем стоимость бруса
      TotalPriceTextile += pocketLength * 50; // 50 грн/м.пог
    }

    // Отлив
    if (activeOptionReflux === 'Так') {
      const refluxWidth = numericWidthReflux / 1000; // Ширина отлива в метрах
      const refluxLength = widthProduct / 1000; // Длина отлива в метрах
      const refluxArea = refluxWidth * refluxLength; // Площадь отлива в м²
      TotalPriceTextile += PriceOfTextile * refluxArea;
    }
    // Итоговая цена
    return Math.round(
      (TotalPriceTextile +
        TotalPriceFilm +
        topFasteningPrice +
        leftFasteningPrice +
        rightFasteningPrice +
        getBottomFasteningPrice +
        snakeLeft +
        snakeCenter +
        priceBelt +
        snakeRight + magnetLeft + magnetCenter + magnetRight) *
        numericCount
    );
  };

  const onSubmit = () => {
    const S = (width * height) / 1000000;
    const totalPrice = calculateTotalPrice();
    const priceWithMarkup = Math.round(
      totalPrice * (1 + markupPercentage / 100)
    );
    // setPrice(totalPrice);
    setList(prevList => [
      ...prevList,
      {
        type: selectedType,
        texttile: texttile,
        fabrics: fabrics,
        color: color,
        rackColor: colorMap[color],
        width: width,
        height: height,
        widthLeftBar: widthBar,
        widthRightBar: toprightBar,
        leftBar: leftBar,
        widthReflux: widthReflux,
        count: count,
        montag: activeOptionInstallation,
        sale: sale,
        belt: activeOptionBelt,
        reflux: activeOptionReflux,
        snakeLeft: activeOptionSnakeLeft,
        snakeCenter: activeOptionSnakeCenter,
        snakeRight: activeOptionSnakeRight,
        top: topSelectedOption,
        left: leftSelectedOption,
        right: rightSelectedOption,
        bottom: bottomSelectedOption,
        markup: markupPercentage,
        price: priceWithMarkup,
        snakeSize: snakeSize,
        magnetLeft: activeOptionMagnetLeft,
        magnetCenter:activeOptionMagnetCenter,
        magnetRight:activeOptionMagnetRight,
        s: S,

        imageData: '',
      },
    ]);
  };

  const calculateTotalS = () => {
    return list.reduce((acc, item) => acc + Number(item.s), 0);
  };
  const totalS = calculateTotalS();
  const calculateTotalListPrice = () => {
    return list.reduce((acc, item) => acc + item.price, 0);
  };

  const autoCalcMontage =
    activeOptionInstallation === 'Так'
      ? (Math.floor(totalS * 350 * 100) / 100) * numericCount > 8500
        ? (Math.floor(totalS * 350 * 100) / 100) * numericCount
        : 8500
      : 0;

  // Если пользователь уже ввёл цену — используем её, иначе берём автоматическую
  const CalcMontage =
    customMontagePrice !== null ? customMontagePrice : autoCalcMontage;

  const totalListPrice = Math.round(calculateTotalListPrice());

  const handleRemoveItem = index => {
    setList(prevList => prevList.filter((_, i) => i !== index));
  };
  


  const discount = (totalListPrice * sale) / 100;
  const discountedPrice = Math.round(totalListPrice - discount);
  const totalPrice = Math.round(
    (sale > 0 ? discountedPrice : totalListPrice) + CalcMontage + woodMontage 
  );


  
  const captureElementAsImage = async elementId => {
    const element = document.getElementById(elementId);
    if (!element) {
      console.error(`Элемент с id ${elementId} не найден`);
      return null;
    }

    await new Promise(resolve => setTimeout(resolve, 500)); // Ждём рендеринга

    try {
      const canvas = await html2canvas(element, { scale: 2 });
      return canvas.toDataURL('image/png');
    } catch (error) {
      console.error('Ошибка при создании снимка:', error);
      return null;
    }
  };

  const generateIMGPDF = async () => {
    const updatedList = [];

    for (let i = 0; i < list.length; i++) {
      const imageData = await captureElementAsImage(`ImageContainer${i}`); // Динамический ID для каждого элемента
      updatedList.push({
        ...list[i],
        imageData, // Сохраняем индивидуальное изображение
      });
    }

    setList(updatedList);
  };

  function generateFilmPDF(item) {
    const pdf = new jsPDF('p', 'pt', 'a4', false);
    const base64Logo =
      'data:image/png;base64,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';
    pdf.addFont('/fonts/DejaVuSans.ttf', 'DejaVuSans', 'normal');
    pdf.addFont('/fonts/DejaVuSans-Bold.ttf', 'DejaVuSans', 'bold');
    pdf.addFont(
      '/fonts/DejaVuSans-BoldOblique.ttf',
      'DejaVuSans',
      'boldoblique'
    );
    pdf.setFont('DejaVuSans', 'normal');

    const logoWidth = 112;
    const logoHeight = 25;
    pdf.setFontSize(12);

    pdf.addImage(base64Logo, 'PNG', 40, 15, logoWidth, logoHeight);
    pdf.setTextColor(128, 128, 128);
    pdf.text('ТОВ «ЮТІСІ», код ЄДРПОУ: 38742406, ', 220, 20);
    pdf.setFontSize(11);
    pdf.text('ІПН 387424010284,тел. +380930332929, +380970332929', 220, 35);
    pdf.setFontSize(12);
    pdf.setTextColor(0, 0, 155);
    pdf.text('www.alltenta.com, e-mail:manager@alltenta.info', 220, 50);
    pdf.setFontSize(14);
    // Начальная позиция
    let yOffset = 80;
    const xOffset = 300;
    const imageWidth = 250;
    const imageHeight = 150;
    const lineSpacing = 16; // Расстояние между строками текста
    const pageHeight = pdf.internal.pageSize.getHeight();
    const marginBottom = 10; // Минимальное расстояние до нижнего края страницы
    pdf.setTextColor(0, 0, 0);
    // Перебираем список и добавляем элементы в PDF
    list.forEach((item, index) => {
      // Высота одного элемента
      const elementHeight = 205;

      // Проверяем, поместится ли элемент на текущую страницу
      if (yOffset + elementHeight + marginBottom > pageHeight) {
        pdf.addPage(); // Создаём новую страницу
        yOffset = 30; // Сбрасываем начальную позицию
      }

      // Заголовок и изображение
      pdf.text(`М'яке вікно ${index + 1}:`, 40, yOffset);
      if (
        item.imageData &&
        item.imageData.startsWith('data:image/png;base64,')
      ) {
        pdf.addImage(
          item.imageData,
          'PNG',
          20,
          yOffset + 10,
          imageWidth,
          imageHeight
        );
      } else {
        console.warn(
          'Некорректное изображение или отсутствует:',
          item.imageData
        );
      }

      // Расположение текста
      let textY = yOffset + 10; // Начальная позиция текста
      pdf.text(`Тип штори: ${item.type || ''}`, xOffset, textY);
      textY += lineSpacing;
      if (item.type !== 'Суцільна з ПВХ' && item.type !== 'Москитна Сітка') {
        pdf.text(`Плівка: ${item.texttile || ''}`, xOffset, textY);
        textY += lineSpacing;
      }
      if (item.type !== 'Суцільна з ПВХ' && item.type !== 'Москитна Сітка') {
        pdf.text(`Тканина: ${item.fabrics || ''}`, xOffset, textY);
        textY += lineSpacing;
      }
      if (item.type === 'Москитна Сітка') {
        pdf.text(`Москитна Сітка: ПВХ Sioen (Бельгія)`, xOffset, textY);
        textY += lineSpacing;
      }
      pdf.text(`Колір окантовки: ${item.color || ''}`, xOffset, textY);
      textY += lineSpacing;

const fastenings = [
  topFastenings[item.top]?.name,
  leftFastenings[item.left]?.name,
  rightFastenings[item.right]?.name,
  bottomFastenings[item.bottom]?.name,
];
const uniqueFastenings = [
  ...new Set(
    fastenings.filter(name => name && name !== 'Намертво'&& name !== 'Карман під обтяжувач')
  ),
];
if (uniqueFastenings.length > 0) {
  const text = `Фурнітура: ${uniqueFastenings.join(', ')}`;

  // Максимальная ширина текста
  const maxWidth = 300;

  const splitText = pdf.splitTextToSize(text, maxWidth);

  pdf.text(splitText, xOffset, textY);

  textY += splitText.length * lineSpacing;
}
      if(item.belt === 'Так'){ 
        pdf.text(
        `Ремінь підв'язувальний`,
        xOffset,
        textY
      );
      textY += lineSpacing;}
       if(item.snakeCenter === true || item.snakeLeft === true || item.snakeRight === true){ 
        pdf.text(
        `Змійка ${item.snakeSize || ''} мм`,
        xOffset,
        textY
      );
      textY += lineSpacing;}
      
      pdf.text(
        `Розмір штори (Ш * В): ${item.width || ''} * ${item.height || ''}`,
        xOffset,
        textY
      );
      textY += lineSpacing;

      pdf.text(`Кількість: ${item.count || ''}`, xOffset, textY);
      textY += lineSpacing;

      pdf.text(`Вартість: ${item.price || ''} грн`, xOffset, textY);
      textY += lineSpacing;

      pdf.text(`Монтаж: ${item.montag || 'Немає'}`, xOffset, textY);

      // Обновляем yOffset для следующего элемента
      yOffset += elementHeight;
    });

    // Добавляем итоговую информацию
    if (yOffset + 3 * lineSpacing + marginBottom > pageHeight) {
      pdf.addPage(); // Если итоговая информация не помещается, создаём новую страницу
      yOffset = 30;
    }
    yOffset += 20;
    pdf.setTextColor(0, 0, 0);
    pdf.text(`Вартість замовлення: ${totalListPrice} грн`, 40, yOffset);
    yOffset += 20;
    if (sale > 0) {
      pdf.setTextColor(255, 0, 0);
      pdf.text(`Знижка: ${sale}%`, 40, yOffset);
      yOffset += 20;
      pdf.setTextColor(0, 0, 0);
      pdf.text(
        `Вартість замовлення: ${discountedPrice} грн (зі знижкою)`,
        40,
        yOffset
      );
      yOffset += 20;
    }
    if (CalcMontage > 0) {
      pdf.setTextColor(0, 0, 0);
      pdf.text(`Монтаж: ${CalcMontage} грн`, 40, yOffset);
      yOffset += 20;
    }
if(woodMontage > 0){pdf.text(`Монтаж брусу: ${woodMontage || ''} грн`, 40, yOffset);
      yOffset += 20;}
    pdf.setFont('DejaVuSans', 'bold');
    pdf.text(`Загальна вартість замовлення: ${totalPrice} грн`, 40, yOffset);
    yOffset += 20;
    pdf.setFont('DejaVuSans', 'normal');
    pdf.text(`Гарантія 36 місяців`, 40, yOffset);
    pdf.setFont('DejaVuSans', 'boldoblique');
    yOffset += 20;
    pdf.setFontSize(11);
    const text = `Діє покупка частинами від банків: Моно, Приват та Пумб, терміном 6-ть місяців без переплат`;

    const lines = pdf.splitTextToSize(text, 500);

    pdf.text(lines, 40, yOffset);

    // смещаем вниз на количество строк
    yOffset += lines.length * 11; // 11 — высота строки (подгони под свой fontSize)

    // Сохраняем PDF
    pdf.save('film-report.pdf');
  }

  const downloadPDF = async () => {
    if (pdfStatus === 'ready') {
      await generateFilmPDF();
      setPdfStatus('generate');
    }
  };

  const handleClick = async () => {
    setPdfStatus('loading');
    await generateIMGPDF();
    setPdfStatus('ready');
  };

  
  return (
    <CalcContainer>
      <CalcName>Калькулятор вартості</CalcName>
      <div>
        <button onClick={() => setModalOpen(true)}>Змінити ціни</button>

        {isModalOpen && (
          <Backdrop onClick={() => setModalOpen(false)}>
            <Modal onClick={e => e.stopPropagation()}>
              <h1>Встановити ціни</h1>
              {[
                { name: 'film1_37', label: 'Плівка 500 мікрон' },
                { name: 'film1_83', label: 'Плівка 800-1000 мікрон' },
                { name: 'film1_37ton', label: 'Плівка 500 мікрон тонована' },
                { name: 'PVH', label: 'Тканина ПВХ 630-650 г/м2' },
                { name: 'PVH_500', label: 'Тканина ПВХ 500-550 г/м2' },
                { name: 'MosquitoNet', label: 'Москитна Сітка' },
                { name: 'Pov_Scob', label: 'Поворотна скоба' },
                { name: 'Belt', label: "Ремінь підв'язувальний" },
                { name: 'Luvers', label: 'Люверс' },
                { name: 'Scob_Luvers', label: 'Скоба + люверс з рем.' },
                { name: 'Numertvo', label: 'Саморізи' },
                { name: 'Lightning', label: 'Блискавка 15 мм' },
                { name: 'Lightning10mm', label: 'Блискавка 10 мм' },
                {name: 'magnet', label:"Магніт"},
              ].map(item => (
                <Wrap key={item.name}>
                  <Label>{item.label}</Label>
                  <input
                    type="number"
                    name={item.name}
                    placeholder={item.label}
                    value={prices[item.name] || ''}
                    onChange={handleChange}
                  />
                </Wrap>
              ))}

              <button onClick={handleSubmit}>Зберегти</button>
              <button
                onClick={() => setModalOpen(false)}
                style={{ marginLeft: 10 }}
              >
                Закрити
              </button>
            </Modal>
          </Backdrop>
        )}
      </div>
      <CalcTypeCon>
        <CalcType>1. Тип штор</CalcType>
        <CalcTypeUl>
          {data.map(item => {
            return (
              <li key={item.type} onClick={() => handleTypeChange(item.type)}>
                <ChooseDiv selected={selectedType === item.type}>
                  <ChoosePhoto src={item.photo} />
                  <ChooseText selected={selectedType === item.type}>
                    {item.type}
                  </ChooseText>
                </ChooseDiv>
              </li>
            );
          })}
        </CalcTypeUl>
      </CalcTypeCon>
      <CalcType>2. Параметри штори</CalcType>
      <CalcWrap>
        <TitleSpan>{getPhotoByType(selectedType).type}</TitleSpan>
        <BoxWrap>
          <CalcPicture>
            <ImageContainer id="ImageContainer">
              {(() => {
                const PhotoComponent = getPhotoByType(selectedType).photo;
                return typeof PhotoComponent === 'function' ? (
                  <PhotoComponent rackColor={colorMap[color] || '#000'} />
                ) : null;
              })()}
             
                  <OverlayPictureTopBar
                    src={top_arrow}
                    selectedType={selectedType}
                  />
                  {/* стрелка (слева сверху) ширины левой стойки  */}
                  <InputWrapperTop selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={widthBar}
                      type="number"
                      onChange={e => setWidthBar(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperTop>
                
            
                  {/* стрелка (справа сверху) ширины правой стойки  */}
                  <OverlayPictureTopBarRight
                    src={top_arrow}
                    selectedType={selectedType}
                  />
                  <InputWrapperTopRight selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={toprightBar}
                      type="number"
                      onChange={e => setTopRightBar(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperTopRight>
                
              {
              selectedType === 'Трикутне' ? (
                <></>
              ) : (
                <>
                  {/* стрелка (слева ) ширины верхней стойки  */}
                  <OverlayPictureLeftBar
                    src={arrowMap[selectedType] || left_arrow}
                    selectedType={selectedType}
                  />
                  <InputWrapperTopLeft selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={leftBar}
                      type="number"
                      onChange={e => setLeftBar(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperTopLeft>
                </>
              )}
              { 
              selectedType === 'Комбінована' ||
              selectedType === 'Комбінована 2'||
  bottomSelectedOption !== 'bottom_num' ? (
                <></>
              ) : (
                <>
                  {/* стрелка (справа ) ширины нижней стойки  */}
                  <OverlayPictureRightBarDown
                    src={arrowMap[selectedType] || left_arrow}
                    selectedType={selectedType}
                  />
                  <InputWrapperBottomRight selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={rightBar}
                      type="number"
                      onChange={e => setRightBar(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperBottomRight>
                </>
              )}
              {selectedType === 'Комбінована' ||
              selectedType === 'Комбінована 2'  ? (
                <>
                {/* стрелка ширины нижней стойки  */}
                  <PicByType selectedType={selectedType} />
                  <InputWrapperBottomBegBar selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={bottomBar}
                      type="number"
                      onChange={e => setBottomBar(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperBottomBegBar>
                </>
              ) : (
                <></>
              )}
              {selectedType === 'Трапеція' ||
              selectedType === 'Трапеція 2' ||
              selectedType === 'Трапеція 3' ||
              selectedType === 'T-образний' ||
              selectedType === 'L-образний' ||
              selectedType === 'L-образний 2' ||
              selectedType === 'Трикутне (Стійки)' ? (
                <>
                  <OverlayPictureB
                    selectedType={selectedType}
                    src={small_arrow}
                  />
                  <InputWrapperB selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={sideOfFilm}
                      type="number"
                      onChange={e => setsideOfFilm(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperB>
                </>
              ) : (
                <></>
              )}
              {selectedType === 'Трапеція 3' ||
              selectedType === 'Трикутне (Стійки)' ? (
                <>
                  <OverlayPictureTrick
                    src={small_arrow}
                    selectedType={selectedType}
                  />
                  <InputWrapperTrick selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={sideOfFilm5}
                      type="number"
                      onChange={e => setsideOfFilm5(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperTrick>
                </>
              ) : (
                <></>
              )}
              {/* внутр ширина снизу   */}
              {selectedType === 'T-образний' ||
              selectedType === 'L-образний 2' ||
              selectedType === 'L-образний' ? (
                <>
                  <OverlayPictureG
                    selectedType={selectedType}
                    src={small_arrow_gori}
                  />
                  <InputWrapperG selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={sideOfFilm2}
                      type="number"
                      onChange={e => setsideOfFilm2(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperG>
                  <OverlayPictureG3
                    selectedType={selectedType}
                    src={small_arrow_gori}
                  />
                  <InputWrapperG3 selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={sideOfFilm4}
                      type="number"
                      onChange={e => setsideOfFilm4(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperG3>
                </>
              ) : (
                <></>
              )}
              {/* внутр ширина слева и справа   */}
              {selectedType === 'T-образний' ? (
                <>
                  <OverlayPictureG2 src={small_arrow_gori} />
                  <InputWrapperG2>
                    <OverlayPictureTopInput
                      value={sideOfFilm3}
                      type="number"
                      onChange={e => setsideOfFilm3(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperG2>
                </>
              ) : (
                <></>
              )}
              <OverlayPictureBottomArrow
                src={bottom_arrow}
                selectedType={selectedType}
              />
              <InputWrapperBottom selectedType={selectedType}>
                <OverlayPictureBottomInput
                  value={widthFilm}
                  type="number"
                  onChange={e =>
                    handleWidthFilmChange(parseFloat(e.target.value))
                  }
                />
                <UnitLabel>мм</UnitLabel>
              </InputWrapperBottom>
              <OverlayPictureBottomArrowBig
                src={bottom_arrow_red}
                selectedType={selectedType}
              />
              <InputWrapperBottomBig selectedType={selectedType}>
                <OverlayPictureBottomInput
                  value={width}
                  type="number"
                  onChange={e => handleWidthChange(parseFloat(e.target.value))}
                />
                <UnitLabel>мм</UnitLabel>
              </InputWrapperBottomBig>
              <OverlayPictureRightArrowBig
                src={right_arrow_red}
                selectedType={selectedType}
              />
              <InputWrapperRightBig selectedType={selectedType}>
                <OverlayPictureBottomInput
                  value={height}
                  type="number"
                  onChange={e => handleHeightChange(parseFloat(e.target.value))}
                />
                <UnitLabel>мм</UnitLabel>
              </InputWrapperRightBig>

              {selectedType === 'Суцільна з ПВХ' ? (
                <></>
              ) : (
                <>
                  <OverlayPictureRightArrow
                    selectedType={selectedType}
                    src={right_arrow}
                  />
                  <InputWrapperRight selectedType={selectedType}>
                    <OverlayPictureBottomInput
                      value={heightFilm}
                      type="number"
                      onChange={e =>
                        handleHeightFilmChange(parseFloat(e.target.value))
                      }
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperRight>
                </>
              )}
              {activeOptionBelt === 'Так' &&
              (selectedType === 'Трапеція' || selectedType === 'Трапеція 2') ? (
                <OverlayPictureBelt
                  src={trap_belt_image}
                  selectedType={selectedType}
                />
              ) : activeOptionBelt === 'Так' ? (
                <OverlayPictureBelt
                  src={sus_belt}
                  selectedType={selectedType}
                />
              ) : null}
              {activeOptionReflux === 'Так' && selectedType === 'T-образний' ? (
                <div>
                  <OverlayPictureRefluxArrow
                    src={arrow_reflux}
                    selectedType={selectedType}
                  />
                  <InputWrapperReflux selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={widthReflux}
                      type="number"
                      onChange={e => setWidthReflux(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperReflux>
                  <OverlayPictureReflux selectedType={selectedType}>
                    {' '}
                    <Treflux rackColor={colorMap[color]} />
                  </OverlayPictureReflux>
                </div>
              ) : activeOptionReflux === 'Так' &&
                selectedType === 'L-образний' ? (
                <div>
                  <OverlayPictureRefluxArrow
                    src={arrow_reflux}
                    selectedType={selectedType}
                  />
                  <InputWrapperReflux selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={widthReflux}
                      type="number"
                      onChange={e => setWidthReflux(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperReflux>
                  <OverlayPictureReflux selectedType={selectedType}>
                    {' '}
                    <Lreflux rackColor={colorMap[color]} />
                  </OverlayPictureReflux>
                </div>
              ) : activeOptionReflux === 'Так' &&
                selectedType === 'L-образний 2' ? (
                <div>
                  <OverlayPictureRefluxArrow
                    src={arrow_reflux}
                    selectedType={selectedType}
                  />
                  <InputWrapperReflux selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={widthReflux}
                      type="number"
                      onChange={e => setWidthReflux(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperReflux>
                  <OverlayPictureReflux selectedType={selectedType}>
                    {' '}
                    <SvgRefluxL2 rackColor={colorMap[color]} />
                  </OverlayPictureReflux>
                </div>
              ) : activeOptionReflux === 'Так' ? (
                <div>
                  <OverlayPictureRefluxArrow
                    src={arrow_reflux}
                    selectedType={selectedType}
                  />
                  <InputWrapperReflux selectedType={selectedType}>
                    <OverlayPictureTopInput
                      value={widthReflux}
                      type="number"
                      onChange={e => setWidthReflux(e.target.value)}
                    />
                    <UnitLabel>мм</UnitLabel>
                  </InputWrapperReflux>
                  <OverlayPictureReflux selectedType={selectedType}>
                    {' '}
                    <Reflux rackColor={colorMap[color]} />
                  </OverlayPictureReflux>
                </div>
              ) : null}

              {activeOptionSnakeLeft === true ? (
                <OverlayPictureSnakeLeft
                  src={snakeSize === 15 ? green_snake : red_snake}
                  selectedType={selectedType}
                />
              ) : (
                <></>
              )}
              {activeOptionSnakeCenter === true ? (
                <OverlayPictureSnakeCenter
                  src={snakeSize === 15 ? green_snake : red_snake}
                  selectedType={selectedType}
                />
              ) : (
                <></>
              )}
              {activeOptionSnakeRight === true ? (
                <OverlayPictureSnakeRight
                  src={snakeSize === 15 ? green_snake : red_snake}
                  selectedType={selectedType}
                />
              ) : (
                <></>
              )}
                 {activeOptionMagnetLeft === true ? (
                <OverlayPictureSnakeLeft
                  src={magnetimg}
                  selectedType={selectedType}
                />
              ) : (
                <></>
              )}
              {activeOptionMagnetCenter === true ? (
                <OverlayPictureSnakeCenter
                  src={magnetimg}
                  selectedType={selectedType}
                />
              ) : (
                <></>
              )}
              {activeOptionMagnetRight === true ? (
                <OverlayPictureSnakeRight
                  src={magnetimg}
                  selectedType={selectedType}
                />
              ) : (
                <></>
              )}

              {bottomSelectedOption === 'bottom_scob_luv' &&
              selectedType === 'T-образний' ? (
                <OverlayPictureBottomScobLuv
                  src={bottob_scob_luv}
                  selectedType={selectedType}
                />
              ) : bottomSelectedOption === 'bottom_scob_luv' &&
                selectedType === 'L-образний' ? (
                <OverlayPictureBottomScobLuv
                  src={bottom_scob_luv_L}
                  selectedType={selectedType}
                />
              ) : bottomSelectedOption === 'bottom_scob_luv' &&
                selectedType === 'L-образний 2' ? (
                <OverlayPictureBottomScobLuv
                  src={bottom_scob_luvL2}
                  selectedType={selectedType}
                />
              ) : bottomSelectedOption === 'bottom_scob_luv' ? (
                <OverlayPictureBottomScobLuv
                  src={bottom_scob_luv}
                  selectedType={selectedType}
                />
              ) : null}

              {bottomSelectedOption === 'bottom_luv' &&
              selectedType === 'T-образний' ? (
                <OverlayPictureBottomScobLuv
                  src={bottom_luv_T}
                  selectedType={selectedType}
                />
              ) : bottomSelectedOption === 'bottom_luv' &&
                selectedType === 'L-образний' ? (
                <OverlayPictureBottomScobLuv
                  src={bottom_luv_L}
                  selectedType={selectedType}
                />
              ) : bottomSelectedOption === 'bottom_luv' &&
                selectedType === 'L-образний 2' ? (
                <OverlayPictureBottomScobLuv
                  src={bottom_luvL2}
                  selectedType={selectedType}
                />
              ) : bottomSelectedOption === 'bottom_luv' ? (
                <OverlayPictureBottomScobLuv
                  src={top_luv}
                  selectedType={selectedType}
                />
              ) : null}

              {bottomSelectedOption === 'bottom_pov_scob' &&
              selectedType === 'T-образний' ? (
                <OverlayPictureBottomPovScob
                  src={bottom_pov_scob_T}
                  selectedType={selectedType}
                />
              ) : bottomSelectedOption === 'bottom_pov_scob' &&
                selectedType === 'L-образний' ? (
                <OverlayPictureBottomPovScob
                  src={bottom_pov_scob_L}
                  selectedType={selectedType}
                />
              ) : bottomSelectedOption === 'bottom_pov_scob' &&
                selectedType === 'L-образний 2' ? (
                <OverlayPictureBottomPovScob
                  src={bottom_pov_scobL2}
                  selectedType={selectedType}
                />
              ) : bottomSelectedOption === 'bottom_pov_scob' ? (
                <OverlayPictureBottomPovScob
                  src={top_pov_scob}
                  selectedType={selectedType}
                />
              ) : null}
              {bottomSelectedOption === 'bottom_karm_pid' &&
              selectedType === 'T-образний' ? (
                <OverlayPictureBottomKarmPid selectedType={selectedType}>
                  <SvgKarmanPidT rackColor={colorMap[color]} />
                </OverlayPictureBottomKarmPid>
              ) : bottomSelectedOption === 'bottom_karm_pid' &&
                selectedType === 'L-образний' ? (
                <OverlayPictureBottomKarmPid selectedType={selectedType}>
                  <SvgKarmanPidL rackColor={colorMap[color]} />
                </OverlayPictureBottomKarmPid>
              ) : bottomSelectedOption === 'bottom_karm_pid' &&
                selectedType === 'L-образний 2' ? (
                <OverlayPictureBottomKarmPid selectedType={selectedType}>
                  <SvgKarmPidL2 rackColor={colorMap[color]} />
                </OverlayPictureBottomKarmPid>
              ) : bottomSelectedOption === 'bottom_karm_pid' ? (
                <OverlayPictureBottomKarmPid selectedType={selectedType}>
                  <SvgKarmanPid rackColor={colorMap[color]} />
                </OverlayPictureBottomKarmPid>
              ) : null}
              {topSelectedOption === 'top_scob_luv' &&
              selectedType === 'Трикутне (Стійки)' ? (
                <OverlayPictureTopScobLuv
                  src={top_scob_luv_trick}
                  selectedType={selectedType}
                />
              ) : topSelectedOption === 'top_scob_luv' &&
                selectedType === 'Трапеція 3' ? (
                <OverlayPictureTopScobLuv
                  src={scobluvtrap3}
                  selectedType={selectedType}
                />
              ) : topSelectedOption === 'top_scob_luv' ? (
                <OverlayPictureTopScobLuv
                  src={top_scob_luv}
                  selectedType={selectedType}
                />
              ) : null}
              {topSelectedOption === 'top_luv' &&
              selectedType === 'Трикутне (Стійки)' ? (
                <OverlayPictureTopLuv
                  src={top_luv_trick}
                  selectedType={selectedType}
                />
              ) : topSelectedOption === 'top_luv' &&
                selectedType === 'Трапеція 3' ? (
                <OverlayPictureTopLuv
                  src={luvtrap3}
                  selectedType={selectedType}
                />
              ) : topSelectedOption === 'top_luv' ? (
                <OverlayPictureTopLuv
                  src={top_luv}
                  selectedType={selectedType}
                />
              ) : null}

              {topSelectedOption === 'top_pov_scob' &&
              selectedType === 'Трикутне (Стійки)' ? (
                <OverlayPictureTopPovScob
                  src={top_pov_scob_trick}
                  selectedType={selectedType}
                />
              ) : topSelectedOption === 'top_pov_scob' &&
                selectedType === 'Трапеція 3' ? (
                <OverlayPictureTopPovScob
                  src={povscobtrap3}
                  selectedType={selectedType}
                />
              ) : topSelectedOption === 'top_pov_scob' ? (
                <OverlayPictureTopPovScob
                  src={top_pov_scob}
                  selectedType={selectedType}
                />
              ) : null}

              
              {leftSelectedOption === 'left_scob_luv' &&
              selectedType === 'Трапеція 3' ? (
                <OverlayPictureLeftScobLuv
                  selectedType={selectedType}
                  src={scobluvtrap3L}
                />
              ) : leftSelectedOption === 'left_scob_luv' ? (
                <OverlayPictureLeftScobLuv
                  selectedType={selectedType}
                  src={left_scob_luv}
                />
              ) : null}
              {leftSelectedOption === 'left_luv' &&
              selectedType === 'Трапеція 3' ? (
                <OverlayPictureLeftLuv
                  selectedType={selectedType}
                  src={luvtrap3L}
                />
              ) : leftSelectedOption === 'left_luv' ? (
                <OverlayPictureLeftLuv
                  selectedType={selectedType}
                  src={left_luv}
                />
              ) : null}
              {leftSelectedOption === 'left_pov_scob' &&
              selectedType === 'Трапеція 3' ? (
                <OverlayPictureLeftPovScob
                  selectedType={selectedType}
                  src={povscobtrap3L}
                />
              ) : leftSelectedOption === 'left_pov_scob' ? (
                <OverlayPictureLeftPovScob
                  selectedType={selectedType}
                  src={left_pov_scob}
                />
              ) : null}

              {rightSelectedOption === 'right_scob_luv' &&
              selectedType === 'Трапеція 3' ? (
                <OverlayPictureRightScobLuv
                  selectedType={selectedType}
                  src={scobluvtrap3R}
                />
              ) : rightSelectedOption === 'right_scob_luv' ? (
                <OverlayPictureRightScobLuv
                  src={right_scob_luv}
                  selectedType={selectedType}
                />
              ) : null}
              {rightSelectedOption === 'right_luv' &&
              selectedType === 'Трапеція 3' ? (
                <OverlayPictureRightLuv
                  selectedType={selectedType}
                  src={luvtrap3R}
                />
              ) : rightSelectedOption === 'right_luv' ? (
                <OverlayPictureRightLuv
                  src={right_luv}
                  selectedType={selectedType}
                />
              ) : null}
              {rightSelectedOption === 'right_pov_scob' &&
              selectedType === 'Трапеція 3' ? (
                <OverlayPictureRightPovScob
                  selectedType={selectedType}
                  src={povscobtrap3R}
                />
              ) : rightSelectedOption === 'right_pov_scob' ? (
                <OverlayPictureRightPovScob
                  src={left_pov_scob}
                  selectedType={selectedType}
                />
              ) : null}
            </ImageContainer>

            <TypeFastening>
              <Title>Тип кріплення:</Title>
              <FasteningParamsWrap>
                <div>
                  {selectedType !== 'Трикутне' && (
                    <FasteningParamsItem>
                      <Title>Верх:</Title>
                      <Fasteningwrap>
                        <FasteningSelect
                          name="Вибір Плівки"
                          onChange={e => setTopSelectedOption(e.target.value)}
                        >
                          <option value="top_num">Намертво</option>
                          <option value="top_scob_luv">
                            Скоба + люверс з рем.
                          </option>
                          <option value="top_luv">Круглі люверси</option>
                          <option value="top_pov_scob">Поворотна скоба</option>
                          <option value="magnet">
                          Магніт
                        </option>
                        </FasteningSelect>
                        <FasteningIconContainer className="IconContainer">
                          <IconButton
                            id="add-curtain-button"
                            aria-label="Додати штору"
                          >
                            +
                          </IconButton>
                        </FasteningIconContainer>
                      </Fasteningwrap>
                    </FasteningParamsItem>
                  )}
                  <FasteningParamsItem>
                    <Title>Зліва:</Title>
                    <Fasteningwrap>
                      <FasteningSelect
                        name="Вибір Плівки"
                        onChange={e => setLeftSelectedOption(e.target.value)}
                      >
                        <option value="left_num">Намертво</option>
                        <option value="left_scob_luv">
                          Скоба + люверс з рем.
                        </option>
                        <option value="left_luv">Круглі люверси</option>

                        <option value="left_pov_scob">Поворотна скоба</option>
                        <option value="magnet">
                          Магніт
                        </option>
                      </FasteningSelect>
                      <FasteningIconContainer className="IconContainer">
                        <IconButton
                          id="add-curtain-button"
                          aria-label="Додати штору"
                        >
                          +
                        </IconButton>
                      </FasteningIconContainer>
                    </Fasteningwrap>
                  </FasteningParamsItem>
                </div>
                <div>
                  <FasteningParamsItem>
                    <Title>Низ:</Title>
                    <Fasteningwrap>
                      <FasteningSelect
                        name="Вибір Плівки"
                        value={bottomSelectedOption}
                        onChange={e => setBottomSelectedOption(e.target.value)}
                      >
                        <option value="bottom_num">Намертво</option>
                        <option value="bottom_scob_luv">
                          Скоба + люверс з рем.
                        </option>
                        <option value="bottom_luv">Круглі люверси</option>

                        <option value="bottom_pov_scob">Поворотна скоба</option>
                        <option value="bottom_karm_pid">
                          Карман під обтяжувач
                        </option>
                         <option value="magnet">
                          Магніт
                        </option>
                      </FasteningSelect>
                      <FasteningIconContainer className="IconContainer">
                        <IconButton
                          id="add-curtain-button"
                          aria-label="Додати штору"
                        >
                          +
                        </IconButton>
                      </FasteningIconContainer>
                    </Fasteningwrap>
                  </FasteningParamsItem>
                  <FasteningParamsItem>
                    <Title>Справа:</Title>
                    <Fasteningwrap>
                      <FasteningSelect
                        name="Вибір Плівки"
                        onChange={e => setRightSelectedOption(e.target.value)}
                      >
                        <option value="right_num">Намертво</option>
                        <option value="right_scob_luv">
                          Скоба + люверс з рем.
                        </option>
                        <option value="right_luv">Круглі люверси</option>
                        <option value="right_pov_scob">Поворотна скоба</option>
                        <option value="magnet">
                          Магніт
                        </option>
                      </FasteningSelect>
                      <FasteningIconContainer className="IconContainer">
                        <IconButton
                          id="add-curtain-button"
                          aria-label="Додати штору"
                        >
                          +
                        </IconButton>
                      </FasteningIconContainer>
                    </Fasteningwrap>
                  </FasteningParamsItem>
                </div>
              </FasteningParamsWrap>
            </TypeFastening>
          </CalcPicture>
          <CalcSettingsWrap>
            <FilmWrap>
              {selectedType === 'Суцільна з ПВХ' ? (
                <></>
              ) : (
                <>
                  <TypeСurtains>
                    <Title>Вибір плівки:</Title>

                    <TextileSelect
                      name="Вибір Плівки"
                      onChange={e => {
                        setTextile(e.target.value);
                      }}
                    >
                      <option value="Achilles 500 мікрон">
                        Achilles 500 мікрон
                      </option>
                      <option value="Achilles 800-1000 мікрон">
                        Achilles 800-1000 мікрон
                      </option>
                      <option value="Achilles 500 мікрон тонована">
                        Achilles 500 мікрон тонована
                      </option>
                    </TextileSelect>
                    <CustomArrow className="custom-arrow">
                      <Plus>+</Plus>
                    </CustomArrow>
                    <ParamСurtains>
                      <ParamСurtainsTitle>
                        Ширина рулона:
                        <ParamСurtainsSpan>{getFilmWidth}м</ParamСurtainsSpan>
                      </ParamСurtainsTitle>
                      <ParamСurtainsTitle>
                        У виробі:{' '}
                        <ParamСurtainsSpan>{inProductFilm}м</ParamСurtainsSpan>
                      </ParamСurtainsTitle>
                    </ParamСurtains>
                  </TypeСurtains>
                </>
              )}

              <TypeСurtains>
                <Title>Вибір тканини:</Title>
                <TextileSelect
                  name="Вибір тканини"
                  value={fabrics}
                  onChange={e => setFabrics(e.target.value)}
                >
                  {Object.entries(fabricsMap).map(([key, fabric]) => (
                    <option key={key} value={key}>
                      {fabric.label}
                    </option>
                  ))}
                </TextileSelect>
                <CustomArrow className="custom-arrow">
                  <Plus>+</Plus>
                </CustomArrow>
              </TypeСurtains>
              <ColorWrap>
                <Title>Колір окантовки:</Title>
                <ColorCont>
                  <ColorSelect
                    name="Колір Тканини"
                    onChange={e => setColor(e.target.value)}
                  >
                    <option value="коричневий">коричневий </option>
                    <option value="жовтий">жовтий </option>
                    <option value="бежевий">бежевий </option>
                    <option value="червоний">червоний </option>
                    <option value="бордовий">бордовий </option>
                    <option value="помаранчевий">помаранчевий </option>
                    <option value="синій">синій </option>
                    <option value="блакитний">блакитний</option>
                    <option value="темно синій">темно синій </option>
                    <option value="зелений">зелений </option>
                    <option value="світло зелений">світло зелений </option>
                    <option value="темно сірий">темно сірий </option>
                    <option value="сірий">сірий </option>
                    <option value="графіт">графіт </option>
                    <option value="металік">металік </option>
                    <option value="чорний">чорний </option>

                    <option value="білий">білий </option>
                  </ColorSelect>
                  <IconContainer className="IconContainer">
                    <IconButton
                      id="add-curtain-button"
                      aria-label="Додати штору"
                    >
                      +
                    </IconButton>
                  </IconContainer>
                </ColorCont>
              </ColorWrap>
              <NumberCurtainsWrap>
                <Title>Кількість штор: </Title>
                <NumberSelectDiv>
                  <NumberInput
                    type="number"
                    id="NumberOfCurtains"
                    name="NumberOfCurtains"
                    value={count}
                    min="1"
                    max="100"
                    onChange={e => setCount(e.target.value)}
                  />
                  шт.
                </NumberSelectDiv>
              </NumberCurtainsWrap>
              <BeltWrap>
                <Title>Ремінь підв'язувальний:</Title>
                <SwitcherWrapper>
                  <SwitcherButton
                    id="switcher-button-1"
                    aria-label="Перемкнути параметр"
                    active={activeOptionBelt === 'Так'}
                    onClick={() => setActiveOptionBelt('Так')}
                  >
                    Так
                  </SwitcherButton>
                  <SwitcherButton
                    id="switcher-button-2"
                    aria-label="Перемкнути параметр"
                    active={activeOptionBelt === 'Hi'}
                    onClick={() => setActiveOptionBelt('Hi')}
                  >
                    Hi
                  </SwitcherButton>
                </SwitcherWrapper>
              </BeltWrap>
              <SubTitle>
                (Встановлюється зліва та права за замовчуванням, якщо відстань
                між ними більша за 1500мм встановлюються додаткові виходячи з
                загальної довжини)
              </SubTitle>
              <InstallationWrap>
                <Title>Націнка:</Title>
                <NumSaleDiv>
                  <NumSaleInput
                    type="number"
                    min="1"
                    max="100"
                    value={markupPercentage === 0 ? '' : markupPercentage}
                    onFocus={e => e.target.select()}
                    onChange={e =>
    setMarkupPercentage(
      e.target.value === '' ? 0 : Number(e.target.value)
    )
  }
                  />
                  <PercentageSign>%</PercentageSign>
                </NumSaleDiv>
              </InstallationWrap>
              <InstallationWrap>
                <Title>Індивідуальна знижка:</Title>
                <NumSaleDiv>
                  <NumSaleInput
                    type="number"
                    id="NumberOfCurtains"
                    name="NumberOfCurtains"
                    value={sale === 0 ? '' : sale}
                    min="1"
                    max="100"
                    onFocus={e => e.target.select()}
                    onChange={e =>
    setSale(
      e.target.value === '' ? 0 : Number(e.target.value)
    )
  }
                  />
                  <PercentageSign>%</PercentageSign>
                </NumSaleDiv>
              </InstallationWrap>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <InstallationWrap>
                  <Title>Монтаж:</Title>
                  <SwitcherWrapperSmall>
                    <SwitcherButton
                      id="switcher-button-3"
                      aria-label="Перемкнути параметр"
                      active={activeOptionInstallation === 'Так'}
                      onClick={() => setActiveOptionInstallation('Так')}
                    >
                      Так
                    </SwitcherButton>
                    <SwitcherButton
                      id="switcher-button-4"
                      aria-label="Перемкнути параметр"
                      active={activeOptionInstallation === 'Hi'}
                      onClick={() => setActiveOptionInstallation('Hi')}
                    >
                      Hi
                    </SwitcherButton>
                  </SwitcherWrapperSmall>
                </InstallationWrap>
                <RefluxWrap>
                  <Title>Відлив:</Title>
                  <SwitcherWrapperSmall>
                    <SwitcherButton
                      id="switcher-button-5"
                      aria-label="Перемкнути параметр"
                      active={activeOptionReflux === 'Так'}
                      onClick={() => setActiveOptionReflux('Так')}
                    >
                      Так
                    </SwitcherButton>
                    <SwitcherButton
                      id="switcher-button-6"
                      aria-label="Перемкнути параметр"
                      active={activeOptionReflux === 'Hi'}
                      onClick={() => setActiveOptionReflux('Hi')}
                    >
                      Hi
                    </SwitcherButton>
                  </SwitcherWrapperSmall>
                </RefluxWrap>
              </div>
              <SnakeWrap>
                <Title>Змійка:</Title>
                <SnakeLabelWrap>
                  <SwitcherWrapperSnake>
                    <SwitcherButton
                      id="switcher-button-7"
                      aria-label="Перемкнути параметр"
                      active={activeOptionSnakeLeft === true}
                      onClick={() =>
                        setActiveOptionSnakeLeft(!activeOptionSnakeLeft)
                      }
                    >
                      Зліва
                    </SwitcherButton>
                    <SwitcherButton
                      id="switcher-button-8"
                      aria-label="Перемкнути параметр"
                      active={activeOptionSnakeCenter === true}
                      onClick={() =>
                        setActiveOptionSnakeCenter(!activeOptionSnakeCenter)
                      }
                    >
                      Центр
                    </SwitcherButton>
                    <SwitcherButton
                      id="switcher-button-9"
                      aria-label="Перемкнути параметр"
                      active={activeOptionSnakeRight === true}
                      onClick={() =>
                        setActiveOptionSnakeRight(!activeOptionSnakeRight)
                      }
                    >
                      Справа
                    </SwitcherButton>
                  </SwitcherWrapperSnake>
                </SnakeLabelWrap>
              </SnakeWrap>
              <ZipWrap>
                <SnakeLabelWrap>
                  <SwitcherWrapperSnake>
                    <SwitcherButton
                      id="switcher-button-10"
                      aria-label="Перемкнути параметр"
                      active={
                        (activeOptionSnakeLeft ||
                          activeOptionSnakeCenter ||
                          activeOptionSnakeRight) &&
                        snakeSize === 10
                      }
                      onClick={() => setSnakeSize(10)}
                    >
                      10 мм
                    </SwitcherButton>
                    <SwitcherButton
                      id="switcher-button-11"
                      aria-label="Перемкнути параметр"
                      active={
                        (activeOptionSnakeLeft ||
                          activeOptionSnakeCenter ||
                          activeOptionSnakeRight) &&
                        snakeSize === 15
                      }
                      onClick={() => setSnakeSize(15)}
                    >
                      15 мм
                    </SwitcherButton>
                  </SwitcherWrapperSnake>
                </SnakeLabelWrap>
              </ZipWrap>
                <SnakeWrap>
                <Title>Магніт:</Title>
                <SnakeLabelWrap>
                  <SwitcherWrapperSnake>
                    <SwitcherButton
                      id="switcher-button-12"
                      aria-label="Перемкнути параметр"
                      active={activeOptionMagnetLeft === true}
                      onClick={() =>
                        setactiveOptionMagnetLeft(!activeOptionMagnetLeft)
                      }
                    >
                      Зліва
                    </SwitcherButton>
                    <SwitcherButton
                      id="switcher-button-13"
                      aria-label="Перемкнути параметр"
                      active={activeOptionMagnetCenter === true}
                      onClick={() =>
                        setactiveOptionMagnetCenter(!activeOptionMagnetCenter)
                      }
                    >
                      Центр
                    </SwitcherButton>
                    <SwitcherButton
                      id="switcher-button-14"
                      aria-label="Перемкнути параметр"
                      active={activeOptionMagnetRight === true}
                      onClick={() =>
                        setactiveOptionMagnetRight(!activeOptionMagnetRight)
                      }
                    >
                      Справа
                    </SwitcherButton>
                  </SwitcherWrapperSnake>
                </SnakeLabelWrap>
              </SnakeWrap>
            </FilmWrap>
          </CalcSettingsWrap>
        </BoxWrap>

        <FasteningButton
          id="fastening-button"
          aria-label="Закріпити параметри"
          onClick={() => onSubmit()}
        >
          Додати до розрахунку +{' '}
        </FasteningButton>
      </CalcWrap>

      {list.map((item, index) => (
        <CalcWrapList key={index}>
          <TitleList>{item.type}</TitleList>
          <RemoveButton
            id={`remove-curtain-${index}`}
            aria-label="Видалити штору"
            onClick={() => handleRemoveItem(index)}
          >
            ✖
          </RemoveButton>
          <BoxWrap>
            <CalcPicture>
              <ImageContainer key={index} id={`ImageContainer${index}`}>
                {(() => {
                  const PhotoComponent = getPhotoByType(item.type).photo;
                  return typeof PhotoComponent === 'function' ? (
                    <PhotoComponent
                      rackColor={colorMap[item.color] || '#000'}
                    />
                  ) : null;
                })()}
                {(item.belt === 'Так' && item.type === 'Трапеція') ||
                (item.belt === 'Так' && item.type === 'Трапеція 2') ? (
                  <OverlayPictureBelt
                    src={trap_belt_image}
                    selectedType={item.type}
                  />
                ) : item.belt === 'Так' ? (
                  <OverlayPictureBelt src={sus_belt} selectedType={item.type} />
                ) : null}
                {item.reflux === 'Так' && item.type === 'T-образний' ? (
                  <OverlayPictureReflux selectedType={item.type}>
                    {' '}
                    <Treflux rackColor={item.rackColor} />
                  </OverlayPictureReflux>
                ) : item.reflux === 'Так' && item.type === 'L-образний' ? (
                  <OverlayPictureReflux selectedType={item.type}>
                    {' '}
                    <Lreflux rackColor={item.rackColor} />
                  </OverlayPictureReflux>
                ) : item.reflux === 'Так' && item.type === 'L-образний 2' ? (
                  <OverlayPictureReflux selectedType={item.type}>
                    {' '}
                    <SvgRefluxL2 rackColor={item.rackColor} />
                  </OverlayPictureReflux>
                ) : item.reflux === 'Так' ? (
                  <OverlayPictureReflux selectedType={item.type}>
                    {' '}
                    <Reflux rackColor={item.rackColor} />
                  </OverlayPictureReflux>
                ) : null}
                {item.snakeLeft === true ? (
                  <OverlayPictureSnakeLeft
                    src={item.snakeSize === 15 ? green_snake : red_snake}
                    selectedType={item.type}
                  />
                ) : (
                  <></>
                )}
                {item.snakeCenter === true ? (
                  <OverlayPictureSnakeCenter
                    src={item.snakeSize === 15 ? green_snake : red_snake}
                    selectedType={item.type}
                  />
                ) : (
                  <></>
                )}
                {item.snakeRight === true ? (
                  <OverlayPictureSnakeRight
                    src={item.snakeSize === 15 ? green_snake : red_snake}
                    selectedType={item.type}
                  />
                ) : (
                  <></>
                )}
                 {item.magnetLeft === true ? (
                  <OverlayPictureSnakeLeft
                    src={magnetimg}
                    selectedType={item.type}
                  />
                ) : (
                  <></>
                )}
                {item.magnetCenter === true ? (
                  <OverlayPictureSnakeCenter
                    src={magnetimg}
                    selectedType={item.type}
                  />
                ) : (
                  <></>
                )}
                {item.magnetRight === true ? (
                  <OverlayPictureSnakeRight
                    src={magnetimg}
                    selectedType={item.type}
                  />
                ) : (
                  <></>
                )}
                {item.top === 'top_scob_luv' &&
                item.type === 'Трикутне (Стійки)' ? (
                  <OverlayPictureTopScobLuv
                    src={top_scob_luv_trick}
                    selectedType={item.type}
                  />
                ) : item.top === 'top_scob_luv' &&
                  item.type === 'Трапеція 3' ? (
                  <OverlayPictureTopScobLuv
                    src={scobluvtrap3}
                    selectedType={selectedType}
                  />
                ) : item.top === 'top_scob_luv' ? (
                  <OverlayPictureTopScobLuv
                    src={top_scob_luv}
                    selectedType={item.type}
                  />
                ) : null}
                {item.top === 'top_luv' && item.type === 'Трикутне (Стійки)' ? (
                  <OverlayPictureTopLuv
                    src={top_luv_trick}
                    selectedType={item.type}
                  />
                ) : item.top === 'top_luv' && item.type === 'Трапеція 3' ? (
                  <OverlayPictureTopLuv
                    src={luvtrap3}
                    selectedType={selectedType}
                  />
                ) : item.top === 'top_luv' ? (
                  <OverlayPictureTopLuv
                    src={top_luv}
                    selectedType={item.type}
                  />
                ) : null}
                {item.top === 'top_pov_scob' &&
                item.type === 'Трикутне (Стійки)' ? (
                  <OverlayPictureTopPovScob
                    src={top_pov_scob_trick}
                    selectedType={item.type}
                  />
                ) : item.top === 'top_pov_scob' &&
                  item.type === 'Трапеція 3' ? (
                  <OverlayPictureTopPovScob
                    src={povscobtrap3}
                    selectedType={selectedType}
                  />
                ) : item.top === 'top_pov_scob' ? (
                  <OverlayPictureTopPovScob
                    src={top_pov_scob}
                    selectedType={item.type}
                  />
                ) : null}
                {item.bottom === 'bottom_scob_luv' &&
                item.type === 'T-образний' ? (
                  <OverlayPictureBottomScobLuv
                    src={bottob_scob_luv}
                    selectedType={item.type}
                  />
                ) : item.bottom === 'bottom_scob_luv' &&
                  item.type === 'L-образний' ? (
                  <OverlayPictureBottomScobLuv
                    src={bottom_scob_luv_L}
                    selectedType={item.type}
                  />
                ) : item.bottom === 'bottom_scob_luv' &&
                  item.type === 'L-образний 2' ? (
                  <OverlayPictureBottomScobLuv
                    src={bottom_scob_luvL2}
                    selectedType={selectedType}
                  />
                ) : item.bottom === 'bottom_scob_luv' ? (
                  <OverlayPictureBottomScobLuv
                    src={bottom_scob_luv}
                    selectedType={item.type}
                  />
                ) : null}
                {item.bottom === 'bottom_luv' && item.type === 'T-образний' ? (
                  <OverlayPictureBottomScobLuv
                    src={bottom_luv_T}
                    selectedType={item.type}
                  />
                ) : item.bottom === 'bottom_luv' &&
                  item.type === 'L-образний' ? (
                  <OverlayPictureBottomScobLuv
                    src={bottom_luv_L}
                    selectedType={item.type}
                  />
                ) : item.bottom === 'bottom_luv' &&
                  item.type === 'L-образний 2' ? (
                  <OverlayPictureBottomScobLuv
                    src={bottom_luvL2}
                    selectedType={selectedType}
                  />
                ) : item.bottom === 'bottom_luv' ? (
                  <OverlayPictureBottomScobLuv
                    src={top_luv}
                    selectedType={item.type}
                  />
                ) : null}

                {item.bottom === 'bottom_pov_scob' &&
                item.type === 'T-образний' ? (
                  <OverlayPictureBottomPovScob
                    src={bottom_pov_scob_T}
                    selectedType={item.type}
                  />
                ) : item.bottom === 'bottom_pov_scob' &&
                  item.type === 'L-образний' ? (
                  <OverlayPictureBottomPovScob
                    src={bottom_pov_scob_L}
                    selectedType={item.type}
                  />
                ) : item.bottom === 'bottom_pov_scob' &&
                  item.type === 'L-образний 2' ? (
                  <OverlayPictureBottomPovScob
                    src={bottom_pov_scobL2}
                    selectedType={selectedType}
                  />
                ) : item.bottom === 'bottom_pov_scob' ? (
                  <OverlayPictureBottomPovScob
                    src={top_pov_scob}
                    selectedType={item.type}
                  />
                ) : null}
                {item.bottom === 'bottom_karm_pid' &&
                item.type === 'T-образний' ? (
                  <OverlayPictureBottomKarmPid selectedType={item.type}>
                    <SvgKarmanPidT rackColor={item.rackColor} />
                  </OverlayPictureBottomKarmPid>
                ) : item.bottom === 'bottom_karm_pid' &&
                  item.type === 'L-образний' ? (
                  <OverlayPictureBottomKarmPid selectedType={item.type}>
                    <SvgKarmanPidL rackColor={item.rackColor} />
                  </OverlayPictureBottomKarmPid>
                ) : item.bottom === 'bottom_karm_pid' &&
                  item.type === 'L-образний 2' ? (
                  <OverlayPictureBottomKarmPid selectedType={selectedType}>
                    <SvgKarmPidL2 rackColor={colorMap[color]} />
                  </OverlayPictureBottomKarmPid>
                ) : item.bottom === 'bottom_karm_pid' ? (
                  <OverlayPictureBottomKarmPid selectedType={item.type}>
                    <SvgKarmanPid rackColor={item.rackColor} />
                  </OverlayPictureBottomKarmPid>
                ) : null}
                
                {item.left === 'left_scob_luv' && item.type === 'Трапеція 3' ? (
                  <OverlayPictureLeftScobLuv
                    selectedType={item.type}
                    src={scobluvtrap3L}
                  />
                ) : item.left === 'left_scob_luv' ? (
                  <OverlayPictureLeftScobLuv
                    selectedType={item.type}
                    src={left_scob_luv}
                  />
                ) : null}
                {item.left === 'left_luv' && item.type === 'Трапеція 3' ? (
                  <OverlayPictureLeftLuv
                    selectedType={item.type}
                    src={luvtrap3L}
                  />
                ) : item.left === 'left_luv' ? (
                  <OverlayPictureLeftLuv
                    selectedType={item.type}
                    src={left_luv}
                  />
                ) : null}
                {item.left === 'left_pov_scob' && item.type === 'Трапеція 3' ? (
                  <OverlayPictureLeftPovScob
                    selectedType={item.type}
                    src={povscobtrap3L}
                  />
                ) : item.left === 'left_pov_scob' ? (
                  <OverlayPictureLeftPovScob
                    selectedType={item.type}
                    src={left_pov_scob}
                  />
                ) : null}
                {item.right === 'right_scob_luv' &&
                item.type === 'Трапеція 3' ? (
                  <OverlayPictureRightScobLuv
                    selectedType={item.type}
                    src={scobluvtrap3R}
                  />
                ) : item.right === 'right_scob_luv' ? (
                  <OverlayPictureRightScobLuv
                    src={right_scob_luv}
                    selectedType={item.type}
                  />
                ) : null}
                {item.right === 'right_luv' && item.type === 'Трапеція 3' ? (
                  <OverlayPictureRightLuv
                    selectedType={item.type}
                    src={luvtrap3R}
                  />
                ) : item.right === 'right_luv' ? (
                  <OverlayPictureRightLuv
                    src={right_luv}
                    selectedType={item.type}
                  />
                ) : null}
                {item.right === 'right_pov_scob' &&
                item.type === 'Трапеція 3' ? (
                  <OverlayPictureRightPovScob
                    selectedType={item.type}
                    src={povscobtrap3R}
                  />
                ) : item.right === 'right_pov_scob' ? (
                  <OverlayPictureRightPovScob
                    src={left_pov_scob}
                    selectedType={item.type}
                  />
                ) : null}
              </ImageContainer>
            </CalcPicture>
            <CalcSettingsWrap>
              {selectedType === 'Суцільна з ПВХ' ? (
                <></>
              ) : (
                <ListItemWrap>
                  <ListParam>Плівка: </ListParam>
                  <ListParamText>{item.texttile}</ListParamText>
                </ListItemWrap>
              )}

              <ListItemWrap>
                <ListParam>Тканина: </ListParam>
                <ListParamText>{item.fabrics}</ListParamText>
              </ListItemWrap>
              <ListItemWrap>
                <ListParam>Колір окантовки: </ListParam>
                <ListParamText>{item.color}</ListParamText>
              </ListItemWrap>
              <ListItemWrap>
                <ListParam>Розмір штори (Ш×В): </ListParam>
                <ListParamText>
                  {item.width} × {item.height} мм
                </ListParamText>
              </ListItemWrap>
              <ListItemWrap>
                <ListParam>Кількість: </ListParam>
                <ListParamText>{item.count} шт</ListParamText>
              </ListItemWrap>
              <ListItemWrap>
                <ListParam>Вартість: </ListParam>
                <ListParamText>
                  <Price>{item.price} </Price> грн
                </ListParamText>
              </ListItemWrap>
              <ListItemWrap>
                <ListParam>Монтаж: </ListParam>
                <ListParamText>{item.montag}</ListParamText>
              </ListItemWrap>
            </CalcSettingsWrap>
          </BoxWrap>
          <OrderButton
            id="order-button"
            aria-label="Оформити замовлення"
            onClick={pdfStatus === 'ready' ? downloadPDF : handleClick}
            disabled={pdfStatus === 'loading'}
          >
            {pdfStatus === 'generate' && 'Згенерувати PDF'}
            {pdfStatus === 'loading' && 'Генерація...'}
            {pdfStatus === 'ready' && 'Завантажити PDF'}
          </OrderButton>
        </CalcWrapList>
      ))}

      {list.length > 0 && (
        <TotalWrap>
          <TotalPrice>
            Вартість замовлення:
            {sale > 0 && (
              <PriceWithoutSale>{totalListPrice} грн</PriceWithoutSale>
            )}
            {discountedPrice} грн
          </TotalPrice>
          <MontageP>
            Монтаж:
            <input
              type="number"
              value={CalcMontage}
              onChange={e => setCustomMontagePrice(Number(e.target.value))}
              style={{
                width: '80px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '2px 4px',
                textAlign: 'right',
              }}
            />
            грн
          </MontageP>
 <MontageP>
            Монтаж брусу:
            <input
              type="number"
              value={woodMontage === 0 ? '' : woodMontage}onFocus={e => e.target.select()}
  onChange={e =>
    setWoodMontage(
      e.target.value === '' ? 0 : Number(e.target.value)
    )
  }
              style={{
                width: '70px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '2px 4px',
                textAlign: 'right',
              }}
            />
            грн
          </MontageP>
          <Sale>
            Знижка:<SaleCount>{sale}%</SaleCount>
          </Sale>
          <TotalPrice>
            Загальна вартість замовлення:
            {totalPrice} грн
          </TotalPrice>
          <DopText>
            За допомогою онлайн калькулятора можна підрахувати попередню
            вартість м'яких вікон.Кінцева вартість може відрізнятися від
            розрахованої на калькуляторі і скаладається на підставі замірів,
            після узгодження із Замовником всіх матеріалів і робіт.
          </DopText>
        </TotalWrap>
      )}
    </CalcContainer>
  );
};

export default Calculator;
